import * as Types from '@coverright/data-access/types/medicare';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdpPlanAggregationQueryVariables = Types.Exact<{
  county: Types.Scalars['String']['input'];
  zip: Types.Scalars['String']['input'];
  dsnpOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  includeHidden?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  planYear?: Types.InputMaybe<Types.PlanYear>;
}>;


export type PdpPlanAggregationQuery = { __typename?: 'Query', pdpPlanAggregation: { __typename?: 'PdpPlanAggregationOutput', monthlyPremiumMax?: any | null, monthlyPremiumMin?: any | null } };

export type CountiesByZipQueryVariables = Types.Exact<{
  zip: Types.Scalars['String']['input'];
}>;


export type CountiesByZipQuery = { __typename?: 'Query', plans_zip_county_fips: Array<{ __typename?: 'ZipCountyFips', city: string, state: string, countyname: string }> };

export type PdpPlanFilterQueryVariables = Types.Exact<{
  filter: Types.PdpPlansFilterInput;
}>;


export type PdpPlanFilterQuery = { __typename?: 'Query', pdpStarRatings: Array<{ __typename?: 'FilterItem', count: number, key: string, name: string }>, pdpCompanies: Array<{ __typename?: 'FilterItem', name: string, count: number, key: string }> };

export type PdpStarRatingsQueryVariables = Types.Exact<{
  filter: Types.PdpPlansFilterInput;
}>;


export type PdpStarRatingsQuery = { __typename?: 'Query', pdpStarRatings: Array<{ __typename?: 'FilterItem', count: number, key: string, name: string }> };

export type MedicarePlanQueryVariables = Types.Exact<{
  bidId: Types.Scalars['String']['input'];
  zip: Types.Scalars['String']['input'];
  countyName: Types.Scalars['String']['input'];
  quoteId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  fullYear?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  planYear?: Types.InputMaybe<Types.PlanYear>;
}>;


export type MedicarePlanQuery = { __typename?: 'Query', plan?: { __typename?: 'Plan', prescriptionDrugDeductible: Array<string>, prescriptionDrugDeductibleShort: Array<string>, bidId: string, monthlyCost?: string | null, primaryCarePhysician: Array<string>, physicianSpecialist: Array<string>, firstWeekOfStay?: string | null, outOfPocketMaximum: Array<string>, inNetworkDeductableAmount?: string | null, maxEnrollmentAmount?: string | null, monthlyPremium?: string | null, orgName?: string | null, parentOrgName?: string | null, outOfPocketAmount?: string | null, planName?: string | null, planType?: string | null, planYear?: Types.PlanYear | null, planTypeCode?: string | null, alternativeMedicine: Array<string>, annualPhysicalExam: Array<string>, chiropractic: Array<string>, nonCommissionable: boolean, ratingNote?: string | null, partBGiveBack?: boolean | null, missingFormularyInAep?: boolean | null, partBAmount?: string | null, SNPType?: Types.SnpType | null, optionalSupplementalBenefits: boolean, optionalSupplementalBenefitsItems: Array<string>, primaryCarePhysicianInNetwork?: string | null, primaryCarePhysicianOutOfNetwork?: string | null, homeHealth: Array<string>, hospitalBenefits: Array<string>, meal: Array<string>, mentalHealth: Array<string>, oTC: Array<string>, preventiveCare: Array<string>, outpatientHospitality: Array<string>, outpatientRehabilitation: Array<string>, physicianSpecialistShort: Array<string>, primaryCarePhysicianShort?: string | null, outpatientSurgery: Array<string>, skilledNursing: Array<string>, transportation: Array<string>, telehealth: Array<string>, drugsCost?: string | null, doctorsCost?: string | null, rating?: number | null, dental?: { __typename?: 'DentalBenefitDto', benefits: Array<string>, maxPlanCoverageAmount?: any | null } | null, essentialExtras?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, everydayOptions?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, doctorsCoverage: Array<{ __typename?: 'DoctorCoverage', npi: string, coverage?: boolean | null, name: string }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', rxcui?: string | null, coverage: boolean, name: string }>, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, extraBenefits: { __typename?: 'ExtraBenefits', drugCoverage: boolean, dental: boolean, vision: boolean, hearing: boolean, transportation: boolean, fitness: boolean, telehealth: boolean, worldwideEmergency: boolean, insulinSavings: boolean, overTheCounter: boolean }, drugDetails?: { __typename?: 'DrugsDetails', catastrophicCoverageDescription: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, catastrophicThreshold: string, catastrophicCopayGeneric: string, catastrophicCopayBranded: string, mrxAltDedAmount: string, mrxAltNoDedTier: string, mrxAltDedAmountShort: string, catastrophicCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, coverageGap: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, initialCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }> } | null, hearing?: { __typename?: 'HearingBenefitDto', benefits: Array<string>, coverageAmountForEars?: any | null } | null, hospitalityDetails: { __typename?: 'HospitalityDetails', ambulanceServices: Array<string>, emergencyRoom: string, urgentServices: string }, otherDefinedSupplemental: { __typename?: 'OtherDefinedSupplementalBenefits', counselingServices: Array<string>, enhancedDiseaseManagement: Array<string>, fitnessBenefit: Array<string>, healthEducation: Array<string>, homeAndBathroomSafety: Array<string>, inHomeSafetyAssessment: Array<string>, medicalNutritionTherapy: Array<string>, nutritionalDietaryBenefit: Array<string>, personalEmergencyResponseSystem: Array<string>, postDischargeInHome: Array<string>, remoteAccessTechnologies: Array<string>, smokingAndTobaccoCessationCounseling: Array<string>, telemonitoringServices: Array<string> }, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null, vision?: { __typename?: 'VisionBenefitDto', benefits: Array<string>, allEyewearMaxMount?: any | null, eyeExamsMaxAmount?: any | null } | null, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, planFiles?: { __typename?: 'PlanFilesOutput', evidenceOfCoverageDocUrl?: string | null, nonDiscriminationNoticeDocUrl?: string | null, preEnrollmentChecklistDocUrl?: string | null, starRatingDescDocUrl?: string | null, summaryOfBenefitsUrl?: string | null, bidId: string } | null } | null };

export type PackageDescriptionByRxcuiQueryVariables = Types.Exact<{
  rxcui: Types.Scalars['String']['input'];
}>;


export type PackageDescriptionByRxcuiQuery = { __typename?: 'Query', packageDescriptionByRxcui: { __typename?: 'DrugPackageOutput', packageDescription: string, unitType: string } };

export type SaveEnabledPdpContractMutationVariables = Types.Exact<{
  input: Types.EnabledPdpContractInput;
}>;


export type SaveEnabledPdpContractMutation = { __typename?: 'Mutation', saveEnabledPdpContract: boolean };

export type MedicareFilterCompaniesQueryVariables = Types.Exact<{
  filter: Types.PlansFilterInput;
}>;


export type MedicareFilterCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }> };

export type SaveEnabledMaContractMutationVariables = Types.Exact<{
  input: Types.EnabledPbpContractInput;
}>;


export type SaveEnabledMaContractMutation = { __typename?: 'Mutation', saveEnabledPbpContract: boolean };

export type EnabledMaContractsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EnabledMaContractsQuery = { __typename?: 'Query', enabledPbpContracts: Array<{ __typename?: 'EnabledPbpContractOutput', company: string, contract: string, enabled: boolean, parentCompany: string }> };

export type EnabledPdpContractsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EnabledPdpContractsQuery = { __typename?: 'Query', enabledPdpContracts: Array<{ __typename?: 'EnabledPdpContractOutput', company: string, contract: string, enabled: boolean, parentCompany: string }> };

export type ManuallyUploadedPlanFilesQueryVariables = Types.Exact<{
  page: Types.PageInput;
  filter?: Types.InputMaybe<Types.PlanFileFilterInput>;
}>;


export type ManuallyUploadedPlanFilesQuery = { __typename?: 'Query', manuallyUploadedPlanFiles: { __typename?: 'PageableManuallyUploadedPlanFileOutput', totalPages: number, totalElements: any, data: Array<{ __typename?: 'ManuallyUploadedPlanFileOutput', bidId: string, evidenceOfCoverageDocUrl?: string | null, nondiscriminationNoticeDocUrl?: string | null, preEnrollmentChecklistDocUrl?: string | null, starRatingDescDocUrl?: string | null, summaryOfBenefitsUrl?: string | null, planYear: Types.PlanYear, orgName?: string | null, parentOrgName?: string | null, planName?: string | null, zip: string }> } };

export type AdminMaPlansQueryVariables = Types.Exact<{
  filter: Types.PlansFilterInput;
  snpFilter: Types.PlansFilterInput;
  page: Types.PageInput;
  sort: Array<Types.PlansSortInput> | Types.PlansSortInput;
  quoteId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type AdminMaPlansQuery = { __typename?: 'Query', plans: { __typename?: 'PageablePlanOutput', totalElements: any, data: Array<{ __typename?: 'Plan', planName?: string | null, planType?: string | null, bidId: string, orgName?: string | null, parentOrgName?: string | null, planYear?: Types.PlanYear | null }> }, snpPlans: { __typename?: 'PageablePlanOutput', totalElements: any, data: Array<{ __typename?: 'Plan', planName?: string | null, planType?: string | null, bidId: string, orgName?: string | null, parentOrgName?: string | null, planYear?: Types.PlanYear | null }> } };

export type MaCompaniesQueryVariables = Types.Exact<{
  filter: Types.PlansFilterInput;
  snpFilter: Types.PlansFilterInput;
}>;


export type MaCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'FilterItem', name: string, key: string, count: number }>, snpCompanies: Array<{ __typename?: 'FilterItem', name: string, key: string, count: number }> };

export type CreateMedicareQuoteForClientMutationVariables = Types.Exact<{
  data: Types.MedicareQuoteInput;
}>;


export type CreateMedicareQuoteForClientMutation = { __typename?: 'Mutation', createMedicareQuoteForClient: { __typename?: 'SaveMedicareQuoteOutput', clientId: any, maQuoteID: any } };

export type PdpPlansTotalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdpPlansTotalQuery = { __typename?: 'Query', pdpPlansTotal?: number | null };

export type PdpPlansSortQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdpPlansSortQuery = { __typename?: 'Query', pdpPlansSort?: Types.PdpField | null };

export type PdpPlanYearQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdpPlanYearQuery = { __typename?: 'Query', pdpPlanYear?: Types.PlanYear | null };

export type PdpFiltersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdpFiltersQuery = { __typename?: 'Query', pdpFilters?: { __typename?: 'PdpFilters', companies?: Array<string> | null, rating?: Array<Types.Rating> | null } | null };

export type MaPlansSortQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MaPlansSortQuery = { __typename?: 'Query', maPlansSort?: Types.Field | null };

export type MaPlansInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MaPlansInfoQuery = { __typename?: 'Query', maPlansInfo?: { __typename?: 'MaPlansInfo', doctorsCheckBoxMessage?: string | null, drugsCheckBoxMessage?: string | null, totalElements?: string | null } | null };

export type CreatePdpQuoteForClientMutationVariables = Types.Exact<{
  userId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  input: Types.PdpQuoteInput;
}>;


export type CreatePdpQuoteForClientMutation = { __typename?: 'Mutation', createPdpQuoteForClient: { __typename?: 'PdpQuoteOutput', cId?: string | null, clientId?: any | null, countyName?: string | null, drugDeliveryType?: Types.MedigapDrugDeliveryType | null, id?: any | null, insulinSavings?: boolean | null, preferredPharmacies: Array<string>, zip?: string | null } };

export type PlansByIdsQueryVariables = Types.Exact<{
  plans: Array<Types.PlanInput> | Types.PlanInput;
  quoteId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type PlansByIdsQuery = { __typename?: 'Query', plansByIds: Array<{ __typename?: 'Plan', prescriptionDrugDeductible: Array<string>, prescriptionDrugDeductibleShort: Array<string>, bidId: string, monthlyCost?: string | null, primaryCarePhysician: Array<string>, physicianSpecialist: Array<string>, firstWeekOfStay?: string | null, outOfPocketMaximum: Array<string>, inNetworkDeductableAmount?: string | null, maxEnrollmentAmount?: string | null, monthlyPremium?: string | null, orgName?: string | null, parentOrgName?: string | null, outOfPocketAmount?: string | null, planName?: string | null, planType?: string | null, planYear?: Types.PlanYear | null, planTypeCode?: string | null, alternativeMedicine: Array<string>, annualPhysicalExam: Array<string>, chiropractic: Array<string>, nonCommissionable: boolean, ratingNote?: string | null, partBGiveBack?: boolean | null, missingFormularyInAep?: boolean | null, partBAmount?: string | null, SNPType?: Types.SnpType | null, optionalSupplementalBenefits: boolean, optionalSupplementalBenefitsItems: Array<string>, primaryCarePhysicianInNetwork?: string | null, primaryCarePhysicianOutOfNetwork?: string | null, homeHealth: Array<string>, hospitalBenefits: Array<string>, meal: Array<string>, mentalHealth: Array<string>, oTC: Array<string>, preventiveCare: Array<string>, outpatientHospitality: Array<string>, outpatientRehabilitation: Array<string>, physicianSpecialistShort: Array<string>, primaryCarePhysicianShort?: string | null, outpatientSurgery: Array<string>, skilledNursing: Array<string>, transportation: Array<string>, telehealth: Array<string>, drugsCost?: string | null, doctorsCost?: string | null, rating?: number | null, dental?: { __typename?: 'DentalBenefitDto', benefits: Array<string>, maxPlanCoverageAmount?: any | null } | null, essentialExtras?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, everydayOptions?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, doctorsCoverage: Array<{ __typename?: 'DoctorCoverage', npi: string, coverage?: boolean | null, name: string }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', rxcui?: string | null, coverage: boolean, name: string }>, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, extraBenefits: { __typename?: 'ExtraBenefits', drugCoverage: boolean, dental: boolean, vision: boolean, hearing: boolean, transportation: boolean, fitness: boolean, telehealth: boolean, worldwideEmergency: boolean, insulinSavings: boolean, overTheCounter: boolean }, drugDetails?: { __typename?: 'DrugsDetails', catastrophicCoverageDescription: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, catastrophicThreshold: string, catastrophicCopayGeneric: string, catastrophicCopayBranded: string, mrxAltDedAmount: string, mrxAltNoDedTier: string, mrxAltDedAmountShort: string, catastrophicCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, coverageGap: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, initialCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }> } | null, hearing?: { __typename?: 'HearingBenefitDto', benefits: Array<string>, coverageAmountForEars?: any | null } | null, hospitalityDetails: { __typename?: 'HospitalityDetails', ambulanceServices: Array<string>, emergencyRoom: string, urgentServices: string }, otherDefinedSupplemental: { __typename?: 'OtherDefinedSupplementalBenefits', counselingServices: Array<string>, enhancedDiseaseManagement: Array<string>, fitnessBenefit: Array<string>, healthEducation: Array<string>, homeAndBathroomSafety: Array<string>, inHomeSafetyAssessment: Array<string>, medicalNutritionTherapy: Array<string>, nutritionalDietaryBenefit: Array<string>, personalEmergencyResponseSystem: Array<string>, postDischargeInHome: Array<string>, remoteAccessTechnologies: Array<string>, smokingAndTobaccoCessationCounseling: Array<string>, telemonitoringServices: Array<string> }, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null, vision?: { __typename?: 'VisionBenefitDto', benefits: Array<string>, allEyewearMaxMount?: any | null, eyeExamsMaxAmount?: any | null } | null, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, planFiles?: { __typename?: 'PlanFilesOutput', evidenceOfCoverageDocUrl?: string | null, nonDiscriminationNoticeDocUrl?: string | null, preEnrollmentChecklistDocUrl?: string | null, starRatingDescDocUrl?: string | null, summaryOfBenefitsUrl?: string | null, bidId: string } | null }> };

export type SavePdpQuoteMutationVariables = Types.Exact<{
  input: Types.PdpQuoteInput;
  userId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type SavePdpQuoteMutation = { __typename?: 'Mutation', savePdpQuote: { __typename?: 'PdpQuoteOutput', cId?: string | null, clientId?: any | null, countyName?: string | null, id?: any | null, insulinSavings?: boolean | null, zip?: string | null } };

export type PdpQuoteQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type PdpQuoteQuery = { __typename?: 'Query', pdpQuote: { __typename?: 'PdpQuoteOutput', cId?: string | null, clientId?: any | null, countyName?: string | null, id?: any | null, insulinSavings?: boolean | null, zip?: string | null, drugDeliveryType?: Types.MedigapDrugDeliveryType | null, preferredPharmacies: Array<string>, preferredDrugs: Array<{ __typename?: 'MedigapPreferredDrugOutput', dosageRxcui: string, frequency: Types.CalcDrugFrequencyPeriod, productRxcui: string, purchaseFrequency: Types.MedigapFrequencyPeriodOutput, quantity: any }> } };

export type PdpPlanQueryVariables = Types.Exact<{
  bidId: Types.Scalars['String']['input'];
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  countyName: Types.Scalars['String']['input'];
  fullYear?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  planYear?: Types.InputMaybe<Types.PlanYear>;
  zip: Types.Scalars['String']['input'];
}>;


export type PdpPlanQuery = { __typename?: 'Query', PdpPlan: { __typename?: 'PdpPlan', SNPType?: Types.SnpType | null, bidId: string, drugsCost?: string | null, monthlyCost?: string | null, contractNumber?: string | null, nonCommissionable: boolean, inNetworkDeductableAmount?: any | null, insulinSavings?: boolean | null, maxEnrollmentAmount?: any | null, missingFormularyInAep?: boolean | null, monthlyPremium?: string | null, orgName?: string | null, outOfPocketAmount?: any | null, parentOrgName?: string | null, partBPremium?: any | null, pbpADsnpZeroDollar?: boolean | null, pbpASnpStateCvgYn?: string | null, planName?: string | null, planYear?: Types.PlanYear | null, planType?: string | null, planTypeCode?: string | null, rating?: number | null, ratingNote?: string | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', packName: string, packRxcui: string, tier?: number | null, rxcui?: string | null, coverage: boolean, name: string }>, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, drugDetails?: { __typename?: 'PdpDrugsDetailsDto', catastrophicCopayBranded: string, catastrophicCopayGeneric: string, catastrophicCoverageDescription: string, catastrophicThreshold: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, mrxAltDedAmount: string, mrxAltDedAmountShort: string, mrxAltNoDedTier: string } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null } };

export type PdpPlanListQueryVariables = Types.Exact<{
  filter: Types.PdpPlansFilterInput;
  page: Types.PageInput;
  fullYear?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  sort: Array<Types.PdpPlansSortInput> | Types.PdpPlansSortInput;
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type PdpPlanListQuery = { __typename?: 'Query', PdpPlans: { __typename?: 'PageablePdpPlanOutput', totalElements: any, hasNext: boolean, data: Array<{ __typename?: 'PdpPlan', SNPType?: Types.SnpType | null, bidId: string, drugsCost?: string | null, monthlyCost?: string | null, contractNumber?: string | null, nonCommissionable: boolean, inNetworkDeductableAmount?: any | null, insulinSavings?: boolean | null, maxEnrollmentAmount?: any | null, missingFormularyInAep?: boolean | null, monthlyPremium?: string | null, orgName?: string | null, outOfPocketAmount?: any | null, parentOrgName?: string | null, partBPremium?: any | null, pbpADsnpZeroDollar?: boolean | null, pbpASnpStateCvgYn?: string | null, planName?: string | null, planYear?: Types.PlanYear | null, planType?: string | null, planTypeCode?: string | null, rating?: number | null, ratingNote?: string | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', packName: string, packRxcui: string, tier?: number | null, rxcui?: string | null, coverage: boolean, name: string }>, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, drugDetails?: { __typename?: 'PdpDrugsDetailsDto', catastrophicCopayBranded: string, catastrophicCopayGeneric: string, catastrophicCoverageDescription: string, catastrophicThreshold: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, mrxAltDedAmount: string, mrxAltDedAmountShort: string, mrxAltNoDedTier: string } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null }> } };

export type DrugTierCoverageOutputFieldsFragment = { __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string };

export type PdpPlanFieldsFragment = { __typename?: 'PdpPlan', SNPType?: Types.SnpType | null, bidId: string, drugsCost?: string | null, monthlyCost?: string | null, contractNumber?: string | null, nonCommissionable: boolean, inNetworkDeductableAmount?: any | null, insulinSavings?: boolean | null, maxEnrollmentAmount?: any | null, missingFormularyInAep?: boolean | null, monthlyPremium?: string | null, orgName?: string | null, outOfPocketAmount?: any | null, parentOrgName?: string | null, partBPremium?: any | null, pbpADsnpZeroDollar?: boolean | null, pbpASnpStateCvgYn?: string | null, planName?: string | null, planYear?: Types.PlanYear | null, planType?: string | null, planTypeCode?: string | null, rating?: number | null, ratingNote?: string | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', packName: string, packRxcui: string, tier?: number | null, rxcui?: string | null, coverage: boolean, name: string }>, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, drugDetails?: { __typename?: 'PdpDrugsDetailsDto', catastrophicCopayBranded: string, catastrophicCopayGeneric: string, catastrophicCoverageDescription: string, catastrophicThreshold: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, mrxAltDedAmount: string, mrxAltDedAmountShort: string, mrxAltNoDedTier: string } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null };

export type DrugTiersOutputFieldsFragment = { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> };

export type IsTherePlanWithFullDrugCoverageQueryVariables = Types.Exact<{
  zip: Types.Scalars['String']['input'];
  countyName: Types.Scalars['String']['input'];
  quoteId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  planYear?: Types.InputMaybe<Types.PlanYear>;
}>;


export type IsTherePlanWithFullDrugCoverageQuery = { __typename?: 'Query', isTherePlanWithFullDrugCoverage: boolean };

export type IsPpoAvailableQueryVariables = Types.Exact<{
  filter: Types.PlansFilterInput;
}>;


export type IsPpoAvailableQuery = { __typename?: 'Query', planTypes: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }> };

export type PlansCountByZipQueryVariables = Types.Exact<{
  zip: Types.Scalars['String']['input'];
}>;


export type PlansCountByZipQuery = { __typename?: 'Query', plansCountByZip: { __typename?: 'PlansCountByZipOutput', maAndPdpPlansParentOrgCount: any, maAndPdpPlansTotalParentOrgCount: any, maPlansCount: any, maPlansTotalCount: any, maPlansParentOrgCount: any, maPlansTotalParentOrgCount: any, pdpPlansParentOrgCount: any, pdpPlansTotalParentOrgCount: any, pdpPlansCount: any, pdpPlansTotalCount: any, zip: string } };

export type MaPlanListQueryVariables = Types.Exact<{
  filter: Types.PlansFilterInput;
  page: Types.PageInput;
  fullYear?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  sort: Array<Types.PlansSortInput> | Types.PlansSortInput;
  quoteId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type MaPlanListQuery = { __typename?: 'Query', plans: { __typename?: 'PageablePlanOutput', doctorsCheckBoxMessage?: string | null, drugsCheckBoxMessage?: string | null, totalElements: any, number: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, data: Array<{ __typename?: 'Plan', prescriptionDrugDeductible: Array<string>, prescriptionDrugDeductibleShort: Array<string>, bidId: string, monthlyCost?: string | null, primaryCarePhysician: Array<string>, physicianSpecialist: Array<string>, firstWeekOfStay?: string | null, outOfPocketMaximum: Array<string>, inNetworkDeductableAmount?: string | null, maxEnrollmentAmount?: string | null, monthlyPremium?: string | null, orgName?: string | null, parentOrgName?: string | null, outOfPocketAmount?: string | null, planName?: string | null, planType?: string | null, planYear?: Types.PlanYear | null, planTypeCode?: string | null, alternativeMedicine: Array<string>, annualPhysicalExam: Array<string>, chiropractic: Array<string>, nonCommissionable: boolean, ratingNote?: string | null, partBGiveBack?: boolean | null, missingFormularyInAep?: boolean | null, partBAmount?: string | null, SNPType?: Types.SnpType | null, optionalSupplementalBenefits: boolean, optionalSupplementalBenefitsItems: Array<string>, primaryCarePhysicianInNetwork?: string | null, primaryCarePhysicianOutOfNetwork?: string | null, homeHealth: Array<string>, hospitalBenefits: Array<string>, meal: Array<string>, mentalHealth: Array<string>, oTC: Array<string>, preventiveCare: Array<string>, outpatientHospitality: Array<string>, outpatientRehabilitation: Array<string>, physicianSpecialistShort: Array<string>, primaryCarePhysicianShort?: string | null, outpatientSurgery: Array<string>, skilledNursing: Array<string>, transportation: Array<string>, telehealth: Array<string>, drugsCost?: string | null, doctorsCost?: string | null, rating?: number | null, dental?: { __typename?: 'DentalBenefitDto', benefits: Array<string>, maxPlanCoverageAmount?: any | null } | null, essentialExtras?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, everydayOptions?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, doctorsCoverage: Array<{ __typename?: 'DoctorCoverage', npi: string, coverage?: boolean | null, name: string }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', rxcui?: string | null, coverage: boolean, name: string }>, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, extraBenefits: { __typename?: 'ExtraBenefits', drugCoverage: boolean, dental: boolean, vision: boolean, hearing: boolean, transportation: boolean, fitness: boolean, telehealth: boolean, worldwideEmergency: boolean, insulinSavings: boolean, overTheCounter: boolean }, drugDetails?: { __typename?: 'DrugsDetails', catastrophicCoverageDescription: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, catastrophicThreshold: string, catastrophicCopayGeneric: string, catastrophicCopayBranded: string, mrxAltDedAmount: string, mrxAltNoDedTier: string, mrxAltDedAmountShort: string, catastrophicCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, coverageGap: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, initialCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }> } | null, hearing?: { __typename?: 'HearingBenefitDto', benefits: Array<string>, coverageAmountForEars?: any | null } | null, hospitalityDetails: { __typename?: 'HospitalityDetails', ambulanceServices: Array<string>, emergencyRoom: string, urgentServices: string }, otherDefinedSupplemental: { __typename?: 'OtherDefinedSupplementalBenefits', counselingServices: Array<string>, enhancedDiseaseManagement: Array<string>, fitnessBenefit: Array<string>, healthEducation: Array<string>, homeAndBathroomSafety: Array<string>, inHomeSafetyAssessment: Array<string>, medicalNutritionTherapy: Array<string>, nutritionalDietaryBenefit: Array<string>, personalEmergencyResponseSystem: Array<string>, postDischargeInHome: Array<string>, remoteAccessTechnologies: Array<string>, smokingAndTobaccoCessationCounseling: Array<string>, telemonitoringServices: Array<string> }, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null, vision?: { __typename?: 'VisionBenefitDto', benefits: Array<string>, allEyewearMaxMount?: any | null, eyeExamsMaxAmount?: any | null } | null, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, planFiles?: { __typename?: 'PlanFilesOutput', evidenceOfCoverageDocUrl?: string | null, nonDiscriminationNoticeDocUrl?: string | null, preEnrollmentChecklistDocUrl?: string | null, starRatingDescDocUrl?: string | null, summaryOfBenefitsUrl?: string | null, bidId: string } | null }> } };

export type MaPlanFieldsFragment = { __typename?: 'Plan', bidId: string, monthlyCost?: string | null, primaryCarePhysician: Array<string>, physicianSpecialist: Array<string>, firstWeekOfStay?: string | null, outOfPocketMaximum: Array<string>, inNetworkDeductableAmount?: string | null, maxEnrollmentAmount?: string | null, monthlyPremium?: string | null, orgName?: string | null, parentOrgName?: string | null, outOfPocketAmount?: string | null, planName?: string | null, planType?: string | null, planYear?: Types.PlanYear | null, planTypeCode?: string | null, alternativeMedicine: Array<string>, annualPhysicalExam: Array<string>, chiropractic: Array<string>, nonCommissionable: boolean, ratingNote?: string | null, partBGiveBack?: boolean | null, missingFormularyInAep?: boolean | null, partBAmount?: string | null, SNPType?: Types.SnpType | null, optionalSupplementalBenefits: boolean, optionalSupplementalBenefitsItems: Array<string>, primaryCarePhysicianInNetwork?: string | null, primaryCarePhysicianOutOfNetwork?: string | null, homeHealth: Array<string>, hospitalBenefits: Array<string>, meal: Array<string>, mentalHealth: Array<string>, oTC: Array<string>, preventiveCare: Array<string>, outpatientHospitality: Array<string>, outpatientRehabilitation: Array<string>, physicianSpecialistShort: Array<string>, primaryCarePhysicianShort?: string | null, outpatientSurgery: Array<string>, skilledNursing: Array<string>, transportation: Array<string>, telehealth: Array<string>, drugsCost?: string | null, doctorsCost?: string | null, rating?: number | null, dental?: { __typename?: 'DentalBenefitDto', benefits: Array<string>, maxPlanCoverageAmount?: any | null } | null, essentialExtras?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, everydayOptions?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, doctorsCoverage: Array<{ __typename?: 'DoctorCoverage', npi: string, coverage?: boolean | null, name: string }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', rxcui?: string | null, coverage: boolean, name: string }>, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, extraBenefits: { __typename?: 'ExtraBenefits', drugCoverage: boolean, dental: boolean, vision: boolean, hearing: boolean, transportation: boolean, fitness: boolean, telehealth: boolean, worldwideEmergency: boolean, insulinSavings: boolean, overTheCounter: boolean }, drugDetails?: { __typename?: 'DrugsDetails', catastrophicCoverageDescription: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, catastrophicThreshold: string, catastrophicCopayGeneric: string, catastrophicCopayBranded: string, mrxAltDedAmount: string, mrxAltNoDedTier: string, mrxAltDedAmountShort: string, catastrophicCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, coverageGap: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, initialCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }> } | null, hearing?: { __typename?: 'HearingBenefitDto', benefits: Array<string>, coverageAmountForEars?: any | null } | null, hospitalityDetails: { __typename?: 'HospitalityDetails', ambulanceServices: Array<string>, emergencyRoom: string, urgentServices: string }, otherDefinedSupplemental: { __typename?: 'OtherDefinedSupplementalBenefits', counselingServices: Array<string>, enhancedDiseaseManagement: Array<string>, fitnessBenefit: Array<string>, healthEducation: Array<string>, homeAndBathroomSafety: Array<string>, inHomeSafetyAssessment: Array<string>, medicalNutritionTherapy: Array<string>, nutritionalDietaryBenefit: Array<string>, personalEmergencyResponseSystem: Array<string>, postDischargeInHome: Array<string>, remoteAccessTechnologies: Array<string>, smokingAndTobaccoCessationCounseling: Array<string>, telemonitoringServices: Array<string> }, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null, vision?: { __typename?: 'VisionBenefitDto', benefits: Array<string>, allEyewearMaxMount?: any | null, eyeExamsMaxAmount?: any | null } | null, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, planFiles?: { __typename?: 'PlanFilesOutput', evidenceOfCoverageDocUrl?: string | null, nonDiscriminationNoticeDocUrl?: string | null, preEnrollmentChecklistDocUrl?: string | null, starRatingDescDocUrl?: string | null, summaryOfBenefitsUrl?: string | null, bidId: string } | null };

export type MaPlanFilterQueryVariables = Types.Exact<{
  filters: Types.PlansFilterInput;
  quoteId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type MaPlanFilterQuery = { __typename?: 'Query', partBPremiumReductionCount: number, planTypes: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }>, companies: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }>, extraBenefits: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }>, SNPTypes: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }>, maxOutOfPocketRanges: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }>, maxCostRanges: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }>, findStarRatings: Array<{ __typename?: 'FilterItem', key: string, name: string, count: number }> };

export type MedicareQuoteQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type MedicareQuoteQuery = { __typename?: 'Query', medicareQuote?: { __typename?: 'MedicareQuoteOutput', abCase?: string | null, createdAt?: any | null, county?: string | null, employed?: boolean | null, pin: string, id: any, clientId: any, favorites: Array<string>, restrictProviderNetwork?: boolean | null, travelMoreThan30DaysAYear?: boolean | null, doctorsWithinNetwork?: boolean | null, work8years?: boolean | null, planYear?: Types.PlanYear | null, enrolled?: Array<string> | null, coverageFilled?: boolean | null, enrolledFilled?: boolean | null, drugDeliveryType?: Types.DrugDeliveryTypeDto | null, hasMore20?: boolean | null, receivesMedicalSupport?: boolean | null, receivesLIS?: boolean | null, receivedBenefits?: boolean | null, governmentAssistant?: Array<string> | null, spouseEmployed?: boolean | null, spouseHasMore20?: boolean | null, zip: string, doctorVisitsNumber?: number | null, specialistVisitsNumber?: number | null, coverage?: Array<string> | null, chronicIllness?: boolean | null, medicarePlanType?: string | null, prepayCoverage?: boolean | null, customAnswers?: string | null, filters?: { __typename?: 'FiltersDto', SNPTypes?: Array<Types.SnpType> | null, companies?: Array<string> | null, extraBenefits: Array<Types.MedicareQuoteFilterExtraBenefit>, maxCostRangeNames?: Array<string> | null, maxOutOfPocketRangeNames?: Array<string> | null, partBPremiumReduction?: boolean | null, planTypes?: Array<string> | null, rating?: Array<Types.Rating> | null, showTopDoctors?: boolean | null, showTopDrugs?: boolean | null } | null, preferredPharmacies: Array<{ __typename?: 'PharmacyLocationDistanceOutput', address: string, distance?: number | null, latitude: number, longitude: number, name: string, npi: string, zip: string }>, preferredDrugs: Array<{ __typename?: 'DrugOutput', frequency: Types.CalcDrugFrequencyPeriod, genericName?: string | null, genericRxcui?: string | null, purchaseFrequency: Types.FrequencyPeriod, isGeneric: boolean, name?: string | null, packName?: string | null, packRxcui: string, quantity: any, rxcui: string, notSupported: boolean }>, preferredDoctors: Array<{ __typename?: 'ProviderOutput', npi: string, name: string, addressesNumber: number, addresses: Array<{ __typename?: 'ProviderAddressOutput', addressLine1: string, addressLine2: string, id: string, isPcp: boolean, specialty: string }>, pcpDetails: Array<{ __typename?: 'ProviderPcpInfoOutput', id: any, pcpId: string, networkDetails: Array<{ __typename?: 'NetworkInfoOutput', name: string, carrierName: string }> }> }> } | null };

export type DrugFragment = { __typename?: 'DrugOutput', frequency: Types.CalcDrugFrequencyPeriod, genericName?: string | null, genericRxcui?: string | null, purchaseFrequency: Types.FrequencyPeriod, isGeneric: boolean, name?: string | null, packName?: string | null, packRxcui: string, quantity: any, rxcui: string, notSupported: boolean };

export type SaveMedicareQuoteMutationVariables = Types.Exact<{
  data: Types.MedicareQuoteInput;
}>;


export type SaveMedicareQuoteMutation = { __typename?: 'Mutation', saveMedicareQuote: { __typename?: 'SaveMedicareQuoteOutput', maQuoteID: any, clientId: any } };

export type FindProviderAddressesByNpiQueryVariables = Types.Exact<{
  npi: Types.Scalars['String']['input'];
}>;


export type FindProviderAddressesByNpiQuery = { __typename?: 'Query', findProviderAddressesByNpi: Array<{ __typename?: 'ProviderAddressOutput', addressLine1: string, addressLine2: string, id: string, specialty: string, isPcp: boolean }> };

export type FindProvidersByFilterQueryVariables = Types.Exact<{
  filterInput: Types.ProviderFilterInput;
}>;


export type FindProvidersByFilterQuery = { __typename?: 'Query', findProvidersByFilter: Array<{ __typename?: 'ProviderOutput', addressesNumber: number, name: string, npi: string, addresses: Array<{ __typename?: 'ProviderAddressOutput', addressLine1: string, addressLine2: string, id: string, specialty: string }>, pcpDetails: Array<{ __typename?: 'ProviderPcpInfoOutput', pcpId: string, id: any, networkDetails: Array<{ __typename?: 'NetworkInfoOutput', carrierName: string, name: string }> }> }> };

export type PackagesQueryVariables = Types.Exact<{
  rxcui: Types.Scalars['String']['input'];
}>;


export type PackagesQuery = { __typename?: 'Query', packages: Array<{ __typename?: 'PackInfoOuput', name?: string | null, rxcui?: string | null }> };

export type DrugPackagesInfoQueryVariables = Types.Exact<{
  rxcui: Types.Scalars['String']['input'];
}>;


export type DrugPackagesInfoQuery = { __typename?: 'Query', drugPackagesInfo?: { __typename?: 'DrugInfoWithPackagesFlags', genericName?: string | null, genericRxcui?: string | null, hasBrandedPackages: boolean, hasGenericPackages: boolean, isGeneric: boolean, name: string, rxcui: string, brandedDetails: Array<{ __typename?: 'BrandedInfo', name: string, rxcui: string }> } | null };

export type DrugsWithPackageQueryVariables = Types.Exact<{
  pairs: Array<Types.ProductPackagePairInput> | Types.ProductPackagePairInput;
}>;


export type DrugsWithPackageQuery = { __typename?: 'Query', drugsWithPackage: Array<{ __typename?: 'DrugInfoWithPack', rxcui?: string | null, packRxcui?: string | null, packName?: string | null, name?: string | null, isGeneric?: boolean | null, genericRxcui?: string | null, genericName?: string | null, notSupported?: boolean | null }> };

export type DrugsQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type DrugsQuery = { __typename?: 'Query', drugs: Array<{ __typename?: 'DrugInfoWithGeneric', genericName?: string | null, genericRxcui?: string | null, isGeneric?: boolean | null, name?: string | null, rxcui?: string | null }> };

export type PdpPlanDiscountsQueryVariables = Types.Exact<{
  bidId: Types.Scalars['String']['input'];
  zip: Types.Scalars['String']['input'];
  countyName: Types.Scalars['String']['input'];
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  fullYear?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  planYear?: Types.InputMaybe<Types.PlanYear>;
}>;


export type PdpPlanDiscountsQuery = { __typename?: 'Query', pdpPlanDiscounts: { __typename?: 'PdpPlan', SNPType?: Types.SnpType | null, bidId: string, drugsCost?: string | null, monthlyCost?: string | null, contractNumber?: string | null, nonCommissionable: boolean, inNetworkDeductableAmount?: any | null, insulinSavings?: boolean | null, maxEnrollmentAmount?: any | null, missingFormularyInAep?: boolean | null, monthlyPremium?: string | null, orgName?: string | null, outOfPocketAmount?: any | null, parentOrgName?: string | null, partBPremium?: any | null, pbpADsnpZeroDollar?: boolean | null, pbpASnpStateCvgYn?: string | null, planName?: string | null, planYear?: Types.PlanYear | null, planType?: string | null, planTypeCode?: string | null, rating?: number | null, ratingNote?: string | null, discountedDrugs?: Array<{ __typename?: 'DrugDiscount', carrierCost: any, costPlusCost?: any | null, discount?: any | null, discountBrand?: Types.DrugDiscountBrand | null, goodRxCost?: any | null, normalizedQuantity?: any | null, rxcui: string, costPlusDetails?: { __typename?: 'CostPlusOfferOutput', brandName: string, form: string, quantity: any, rxcui: string, unitPrice: any, url: string } | null, goodRxDetails?: { __typename?: 'GoodRxOfferOutput', dosage: string, form: string, mobileUrl: string, price?: string | null, quantity: any, rxcui: string, url: string } | null }> | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', packName: string, packRxcui: string, tier?: number | null, rxcui?: string | null, coverage: boolean, name: string }>, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, drugDetails?: { __typename?: 'PdpDrugsDetailsDto', catastrophicCopayBranded: string, catastrophicCopayGeneric: string, catastrophicCoverageDescription: string, catastrophicThreshold: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, mrxAltDedAmount: string, mrxAltDedAmountShort: string, mrxAltNoDedTier: string } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null } };

export type MaPlanDiscountsQueryVariables = Types.Exact<{
  bidId: Types.Scalars['String']['input'];
  zip: Types.Scalars['String']['input'];
  countyName: Types.Scalars['String']['input'];
  quoteId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  fullYear?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  planYear?: Types.InputMaybe<Types.PlanYear>;
}>;


export type MaPlanDiscountsQuery = { __typename?: 'Query', maPlanDiscounts?: { __typename?: 'Plan', prescriptionDrugDeductible: Array<string>, prescriptionDrugDeductibleShort: Array<string>, bidId: string, monthlyCost?: string | null, primaryCarePhysician: Array<string>, physicianSpecialist: Array<string>, firstWeekOfStay?: string | null, outOfPocketMaximum: Array<string>, inNetworkDeductableAmount?: string | null, maxEnrollmentAmount?: string | null, monthlyPremium?: string | null, orgName?: string | null, parentOrgName?: string | null, outOfPocketAmount?: string | null, planName?: string | null, planType?: string | null, planYear?: Types.PlanYear | null, planTypeCode?: string | null, alternativeMedicine: Array<string>, annualPhysicalExam: Array<string>, chiropractic: Array<string>, nonCommissionable: boolean, ratingNote?: string | null, partBGiveBack?: boolean | null, missingFormularyInAep?: boolean | null, partBAmount?: string | null, SNPType?: Types.SnpType | null, optionalSupplementalBenefits: boolean, optionalSupplementalBenefitsItems: Array<string>, primaryCarePhysicianInNetwork?: string | null, primaryCarePhysicianOutOfNetwork?: string | null, homeHealth: Array<string>, hospitalBenefits: Array<string>, meal: Array<string>, mentalHealth: Array<string>, oTC: Array<string>, preventiveCare: Array<string>, outpatientHospitality: Array<string>, outpatientRehabilitation: Array<string>, physicianSpecialistShort: Array<string>, primaryCarePhysicianShort?: string | null, outpatientSurgery: Array<string>, skilledNursing: Array<string>, transportation: Array<string>, telehealth: Array<string>, drugsCost?: string | null, doctorsCost?: string | null, rating?: number | null, discountedDrugs?: Array<{ __typename?: 'DrugDiscount', carrierCost: any, costPlusCost?: any | null, discount?: any | null, discountBrand?: Types.DrugDiscountBrand | null, goodRxCost?: any | null, normalizedQuantity?: any | null, rxcui: string, costPlusDetails?: { __typename?: 'CostPlusOfferOutput', brandName: string, form: string, quantity: any, rxcui: string, unitPrice: any, url: string } | null, goodRxDetails?: { __typename?: 'GoodRxOfferOutput', dosage: string, form: string, mobileUrl: string, price?: string | null, quantity: any, rxcui: string, url: string } | null }> | null, dental?: { __typename?: 'DentalBenefitDto', benefits: Array<string>, maxPlanCoverageAmount?: any | null } | null, essentialExtras?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, everydayOptions?: { __typename?: 'SupplementalPackageDto', title: string, description: string, ssbciDisclaimer?: string | null } | null, doctorsCoverage: Array<{ __typename?: 'DoctorCoverage', npi: string, coverage?: boolean | null, name: string }>, drugsCoverage: Array<{ __typename?: 'DrugCoverage', rxcui?: string | null, coverage: boolean, name: string }>, drugPrices: Array<{ __typename?: 'DrugPriceOutput', catastrophicPrice: string, coverageGapPrice: string, initialCoveragePrice: string, name: string, price: string, unitPrice: string, rxcui: string, tier?: number | null, quoteQuantity: string, isCoveredByPlan: boolean, packageDescription: string, quantityLimit?: string | null, isAggregatedPrice: boolean, isGeneric: boolean, isInsulinDrug: boolean, error: boolean }>, extraBenefits: { __typename?: 'ExtraBenefits', drugCoverage: boolean, dental: boolean, vision: boolean, hearing: boolean, transportation: boolean, fitness: boolean, telehealth: boolean, worldwideEmergency: boolean, insulinSavings: boolean, overTheCounter: boolean }, drugDetails?: { __typename?: 'DrugsDetails', catastrophicCoverageDescription: string, coverageGapDescription: string, initialCoverageDescription: string, initialCoverageLimit: string, catastrophicThreshold: string, catastrophicCopayGeneric: string, catastrophicCopayBranded: string, mrxAltDedAmount: string, mrxAltNoDedTier: string, mrxAltDedAmountShort: string, catastrophicCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, coverageGap: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }>, initialCoverage: Array<{ __typename?: 'PharmacyTier', title?: string | null, items: Array<{ __typename?: 'DrugTier', title: string, values: Array<string> }> }> } | null, hearing?: { __typename?: 'HearingBenefitDto', benefits: Array<string>, coverageAmountForEars?: any | null } | null, hospitalityDetails: { __typename?: 'HospitalityDetails', ambulanceServices: Array<string>, emergencyRoom: string, urgentServices: string }, otherDefinedSupplemental: { __typename?: 'OtherDefinedSupplementalBenefits', counselingServices: Array<string>, enhancedDiseaseManagement: Array<string>, fitnessBenefit: Array<string>, healthEducation: Array<string>, homeAndBathroomSafety: Array<string>, inHomeSafetyAssessment: Array<string>, medicalNutritionTherapy: Array<string>, nutritionalDietaryBenefit: Array<string>, personalEmergencyResponseSystem: Array<string>, postDischargeInHome: Array<string>, remoteAccessTechnologies: Array<string>, smokingAndTobaccoCessationCounseling: Array<string>, telemonitoringServices: Array<string> }, pharmacyCoverage?: { __typename?: 'PharmacyCoverageOutput', name: string, inNetwork: boolean, npi: string } | null, vision?: { __typename?: 'VisionBenefitDto', benefits: Array<string>, allEyewearMaxMount?: any | null, eyeExamsMaxAmount?: any | null } | null, drugCostMonthlyBreakdown?: { __typename?: 'DrugCostMonthlyBreakdownOutput', totalClientCost: string, costs: Array<{ __typename?: 'DrugCostOutput', name: string, month: number, cost: string, rxcui: string, stage: Types.DrugCalculationStage, numericCost: any, packageName: string }>, coverageEntry: Array<{ __typename?: 'CoverageEntryOutput', stage: Types.DrugCalculationStage, month: number }>, monthlyCosts: Array<{ __typename?: 'MonthlyTotalCost', amount: any, amountString: string, month: number, stage: Types.DrugCalculationStage }> } | null, quoteDrugsTiers?: { __typename?: 'QuoteDrugTiersOutput', deliveryType: Types.DrugDeliveryMethod, pharmacyName: string, npi: string, catastrophicCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }>, initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', tier: Types.DrugTierOutput, coverage: string, tierName: string }> } | null, drugsTiers30Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers30Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Preferred?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, drugsTiers90Standard?: { __typename?: 'DrugTiersOutput', initialCoverageDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }>, coverageGapDrugTiers: Array<{ __typename?: 'DrugTierCoverageOutput', coverage: string, tierName: string, tier: Types.DrugTierOutput }> } | null, planFiles?: { __typename?: 'PlanFilesOutput', evidenceOfCoverageDocUrl?: string | null, nonDiscriminationNoticeDocUrl?: string | null, preEnrollmentChecklistDocUrl?: string | null, starRatingDescDocUrl?: string | null, summaryOfBenefitsUrl?: string | null, bidId: string } | null } | null };

export type RegulatoryVariableQueryVariables = Types.Exact<{
  year: Types.PlanYear;
}>;


export type RegulatoryVariableQuery = { __typename?: 'Query', regulatoryVariable: { __typename?: 'RegulatoryVariable', catastrophicCoinsurance: number, catastrophicCoinsuranceBranded: number, catastrophicCoinsuranceGeneric: number, catastrophicCopayBranded: any, catastrophicCopayGeneric: any, catastrophicThreshold: any, coverageGapCoinsurance: number, coverageGapCopayBranded: any, coverageGapCopayGeneric: any, defaultDrugDeductible: any, defaultInitialCoverageThreshold: any, dsnpBrandedDrugMaxClientCopay: any, dsnpGenericDrugMaxClientCopay: any, initialCopayBranded: any, initialCopayGeneric: any, insulinPrice: any, manufacturerTroop: number, manufacturerInitialCoverageSharePerc: number } };

export type PdpCompaniesQueryVariables = Types.Exact<{
  filter: Types.PdpPlansFilterInput;
}>;


export type PdpCompaniesQuery = { __typename?: 'Query', pdpCompanies: Array<{ __typename?: 'FilterItem', name: string, count: number, key: string }> };

export const DrugTierCoverageOutputFieldsFragmentDoc = gql`
    fragment DrugTierCoverageOutputFields on DrugTierCoverageOutput {
  tier
  coverage
  tierName
}
    `;
export const DrugTiersOutputFieldsFragmentDoc = gql`
    fragment DrugTiersOutputFields on DrugTiersOutput {
  initialCoverageDrugTiers {
    coverage
    tierName
    tier
  }
  coverageGapDrugTiers {
    coverage
    tierName
    tier
  }
}
    `;
export const PdpPlanFieldsFragmentDoc = gql`
    fragment PdpPlanFields on PdpPlan {
  SNPType
  bidId
  drugsCost
  monthlyCost
  contractNumber
  nonCommissionable
  quoteDrugsTiers(supplyDuration: ONE_MONTH) {
    deliveryType
    pharmacyName
    catastrophicCoverageDrugTiers {
      ...DrugTierCoverageOutputFields
    }
    coverageGapDrugTiers {
      ...DrugTierCoverageOutputFields
    }
    npi
    initialCoverageDrugTiers {
      ...DrugTierCoverageOutputFields
    }
  }
  drugPrices {
    catastrophicPrice
    coverageGapPrice
    initialCoveragePrice
    name
    price
    unitPrice
    rxcui
    tier
    quoteQuantity
    isCoveredByPlan
    packageDescription
    quantityLimit
    isAggregatedPrice
    isGeneric
    isInsulinDrug
    error
  }
  drugsCoverage {
    packName
    packRxcui
    tier
    rxcui
    coverage
    name
  }
  drugCostMonthlyBreakdown {
    totalClientCost
    costs {
      name
      month
      cost
      rxcui
      stage
      numericCost
      packageName
    }
    coverageEntry {
      stage
      month
    }
    monthlyCosts {
      amount
      amountString
      month
      stage
    }
  }
  drugDetails {
    catastrophicCopayBranded
    catastrophicCopayGeneric
    catastrophicCoverageDescription
    catastrophicThreshold
    coverageGapDescription
    initialCoverageDescription
    initialCoverageLimit
    mrxAltDedAmount
    mrxAltDedAmountShort
    mrxAltNoDedTier
  }
  drugsTiers30Preferred: drugTiers(
    supplyDuration: ONE_MONTH
    deliveryMethod: PREFERRED_RETAIL
  ) {
    ...DrugTiersOutputFields
  }
  drugsTiers30Standard: drugTiers(
    supplyDuration: ONE_MONTH
    deliveryMethod: STANDARD_RETAIL
  ) {
    ...DrugTiersOutputFields
  }
  drugsTiers90Preferred: drugTiers(
    supplyDuration: THREE_MONTHS
    deliveryMethod: PREFERRED_MAIL
  ) {
    ...DrugTiersOutputFields
  }
  drugsTiers90Standard: drugTiers(
    supplyDuration: THREE_MONTHS
    deliveryMethod: STANDARD_MAIL
  ) {
    ...DrugTiersOutputFields
  }
  pharmacyCoverage {
    name
    inNetwork
    npi
  }
  inNetworkDeductableAmount
  insulinSavings
  maxEnrollmentAmount
  missingFormularyInAep
  monthlyPremium
  orgName
  outOfPocketAmount
  parentOrgName
  partBPremium
  pbpADsnpZeroDollar
  pbpASnpStateCvgYn
  planName
  planYear
  planType
  planTypeCode
  rating
  ratingNote
}
    ${DrugTierCoverageOutputFieldsFragmentDoc}
${DrugTiersOutputFieldsFragmentDoc}`;
export const MaPlanFieldsFragmentDoc = gql`
    fragment MaPlanFields on Plan {
  bidId
  monthlyCost
  primaryCarePhysician
  physicianSpecialist
  firstWeekOfStay
  outOfPocketMaximum
  inNetworkDeductableAmount
  maxEnrollmentAmount
  monthlyPremium
  orgName
  parentOrgName
  outOfPocketAmount
  planName
  planType
  planYear
  planTypeCode
  alternativeMedicine
  annualPhysicalExam
  chiropractic
  nonCommissionable
  dental {
    benefits
    maxPlanCoverageAmount
  }
  ratingNote
  partBGiveBack
  missingFormularyInAep
  partBAmount
  SNPType
  optionalSupplementalBenefits
  optionalSupplementalBenefitsItems
  essentialExtras {
    title
    description
    ssbciDisclaimer
  }
  everydayOptions {
    title
    description
    ssbciDisclaimer
  }
  primaryCarePhysicianInNetwork
  primaryCarePhysicianOutOfNetwork
  doctorsCoverage {
    npi
    coverage
    name
  }
  drugsCoverage {
    rxcui
    coverage
    name
  }
  drugPrices {
    catastrophicPrice
    coverageGapPrice
    initialCoveragePrice
    name
    price
    unitPrice
    rxcui
    tier
    quoteQuantity
    isCoveredByPlan
    packageDescription
    quantityLimit
    isAggregatedPrice
    isGeneric
    isInsulinDrug
    error
  }
  extraBenefits {
    drugCoverage
    dental
    vision
    hearing
    transportation
    fitness
    telehealth
    worldwideEmergency
    insulinSavings
    overTheCounter
  }
  drugDetails {
    catastrophicCoverage {
      items {
        title
        values
      }
      title
    }
    catastrophicCoverageDescription
    coverageGap {
      items {
        title
        values
      }
      title
    }
    coverageGapDescription
    initialCoverage {
      items {
        title
        values
      }
      title
    }
    initialCoverageDescription
    initialCoverageLimit
    catastrophicThreshold
    catastrophicCopayGeneric
    catastrophicCopayBranded
    mrxAltDedAmount
    mrxAltNoDedTier
    mrxAltDedAmountShort
  }
  hearing {
    benefits
    coverageAmountForEars
  }
  homeHealth
  hospitalBenefits
  hospitalityDetails {
    ambulanceServices
    emergencyRoom
    urgentServices
  }
  meal
  mentalHealth
  oTC
  otherDefinedSupplemental {
    counselingServices
    enhancedDiseaseManagement
    fitnessBenefit
    healthEducation
    homeAndBathroomSafety
    inHomeSafetyAssessment
    medicalNutritionTherapy
    nutritionalDietaryBenefit
    personalEmergencyResponseSystem
    postDischargeInHome
    remoteAccessTechnologies
    smokingAndTobaccoCessationCounseling
    telemonitoringServices
  }
  pharmacyCoverage {
    name
    inNetwork
    npi
  }
  preventiveCare
  outpatientHospitality
  outpatientRehabilitation
  physicianSpecialistShort
  primaryCarePhysicianShort
  outpatientSurgery
  skilledNursing
  transportation
  telehealth
  vision {
    benefits
    allEyewearMaxMount
    eyeExamsMaxAmount
  }
  drugsCost
  doctorsCost
  rating
  drugCostMonthlyBreakdown {
    totalClientCost
    costs {
      name
      month
      cost
      rxcui
      stage
      numericCost
      packageName
    }
    coverageEntry {
      stage
      month
    }
    monthlyCosts {
      amount
      amountString
      month
      stage
    }
  }
  quoteDrugsTiers(supplyDuration: ONE_MONTH) {
    deliveryType
    pharmacyName
    catastrophicCoverageDrugTiers {
      ...DrugTierCoverageOutputFields
    }
    coverageGapDrugTiers {
      ...DrugTierCoverageOutputFields
    }
    npi
    initialCoverageDrugTiers {
      ...DrugTierCoverageOutputFields
    }
  }
  drugsTiers30Preferred: drugTiers(
    supplyDuration: ONE_MONTH
    deliveryMethod: PREFERRED_RETAIL
  ) {
    initialCoverageDrugTiers {
      coverage
      tierName
      tier
    }
    coverageGapDrugTiers {
      coverage
      tierName
      tier
    }
  }
  drugsTiers30Standard: drugTiers(
    supplyDuration: ONE_MONTH
    deliveryMethod: STANDARD_RETAIL
  ) {
    initialCoverageDrugTiers {
      coverage
      tierName
      tier
    }
    coverageGapDrugTiers {
      coverage
      tierName
      tier
    }
  }
  drugsTiers90Preferred: drugTiers(
    supplyDuration: THREE_MONTHS
    deliveryMethod: PREFERRED_MAIL
  ) {
    initialCoverageDrugTiers {
      coverage
      tierName
      tier
    }
    coverageGapDrugTiers {
      coverage
      tierName
      tier
    }
  }
  drugsTiers90Standard: drugTiers(
    supplyDuration: THREE_MONTHS
    deliveryMethod: STANDARD_MAIL
  ) {
    initialCoverageDrugTiers {
      coverage
      tierName
      tier
    }
    coverageGapDrugTiers {
      coverage
      tierName
      tier
    }
  }
  planFiles {
    evidenceOfCoverageDocUrl
    nonDiscriminationNoticeDocUrl
    preEnrollmentChecklistDocUrl
    starRatingDescDocUrl
    summaryOfBenefitsUrl
    bidId
  }
}
    ${DrugTierCoverageOutputFieldsFragmentDoc}`;
export const DrugFragmentDoc = gql`
    fragment Drug on DrugOutput {
  frequency
  genericName
  genericRxcui
  purchaseFrequency
  isGeneric
  name
  packName
  packRxcui
  quantity
  rxcui
  notSupported
}
    `;
export const PdpPlanAggregationDocument = gql`
    query pdpPlanAggregation($county: String!, $zip: String!, $dsnpOnly: Boolean, $includeHidden: Boolean, $planYear: PlanYear) {
  pdpPlanAggregation(
    county: $county
    zip: $zip
    dsnpOnly: $dsnpOnly
    includeHidden: $includeHidden
    planYear: $planYear
  ) {
    monthlyPremiumMax
    monthlyPremiumMin
  }
}
    `;

/**
 * __usePdpPlanAggregationQuery__
 *
 * To run a query within a React component, call `usePdpPlanAggregationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlanAggregationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlanAggregationQuery({
 *   variables: {
 *      county: // value for 'county'
 *      zip: // value for 'zip'
 *      dsnpOnly: // value for 'dsnpOnly'
 *      includeHidden: // value for 'includeHidden'
 *      planYear: // value for 'planYear'
 *   },
 * });
 */
export function usePdpPlanAggregationQuery(baseOptions: Apollo.QueryHookOptions<PdpPlanAggregationQuery, PdpPlanAggregationQueryVariables> & ({ variables: PdpPlanAggregationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlanAggregationQuery, PdpPlanAggregationQueryVariables>(PdpPlanAggregationDocument, options);
      }
export function usePdpPlanAggregationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlanAggregationQuery, PdpPlanAggregationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlanAggregationQuery, PdpPlanAggregationQueryVariables>(PdpPlanAggregationDocument, options);
        }
export function usePdpPlanAggregationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlanAggregationQuery, PdpPlanAggregationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlanAggregationQuery, PdpPlanAggregationQueryVariables>(PdpPlanAggregationDocument, options);
        }
export type PdpPlanAggregationQueryHookResult = ReturnType<typeof usePdpPlanAggregationQuery>;
export type PdpPlanAggregationLazyQueryHookResult = ReturnType<typeof usePdpPlanAggregationLazyQuery>;
export type PdpPlanAggregationSuspenseQueryHookResult = ReturnType<typeof usePdpPlanAggregationSuspenseQuery>;
export type PdpPlanAggregationQueryResult = Apollo.QueryResult<PdpPlanAggregationQuery, PdpPlanAggregationQueryVariables>;
export const CountiesByZipDocument = gql`
    query countiesByZip($zip: String!) {
  plans_zip_county_fips(where: {zip: {_eq: $zip}}) {
    city
    state
    countyname
  }
}
    `;

/**
 * __useCountiesByZipQuery__
 *
 * To run a query within a React component, call `useCountiesByZipQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountiesByZipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountiesByZipQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useCountiesByZipQuery(baseOptions: Apollo.QueryHookOptions<CountiesByZipQuery, CountiesByZipQueryVariables> & ({ variables: CountiesByZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountiesByZipQuery, CountiesByZipQueryVariables>(CountiesByZipDocument, options);
      }
export function useCountiesByZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountiesByZipQuery, CountiesByZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountiesByZipQuery, CountiesByZipQueryVariables>(CountiesByZipDocument, options);
        }
export function useCountiesByZipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountiesByZipQuery, CountiesByZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountiesByZipQuery, CountiesByZipQueryVariables>(CountiesByZipDocument, options);
        }
export type CountiesByZipQueryHookResult = ReturnType<typeof useCountiesByZipQuery>;
export type CountiesByZipLazyQueryHookResult = ReturnType<typeof useCountiesByZipLazyQuery>;
export type CountiesByZipSuspenseQueryHookResult = ReturnType<typeof useCountiesByZipSuspenseQuery>;
export type CountiesByZipQueryResult = Apollo.QueryResult<CountiesByZipQuery, CountiesByZipQueryVariables>;
export const PdpPlanFilterDocument = gql`
    query pdpPlanFilter($filter: PdpPlansFilterInput!) {
  pdpStarRatings(filter: $filter) {
    count
    key
    name
  }
  pdpCompanies(filter: $filter) {
    name
    count
    key
  }
}
    `;

/**
 * __usePdpPlanFilterQuery__
 *
 * To run a query within a React component, call `usePdpPlanFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlanFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlanFilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePdpPlanFilterQuery(baseOptions: Apollo.QueryHookOptions<PdpPlanFilterQuery, PdpPlanFilterQueryVariables> & ({ variables: PdpPlanFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlanFilterQuery, PdpPlanFilterQueryVariables>(PdpPlanFilterDocument, options);
      }
export function usePdpPlanFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlanFilterQuery, PdpPlanFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlanFilterQuery, PdpPlanFilterQueryVariables>(PdpPlanFilterDocument, options);
        }
export function usePdpPlanFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlanFilterQuery, PdpPlanFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlanFilterQuery, PdpPlanFilterQueryVariables>(PdpPlanFilterDocument, options);
        }
export type PdpPlanFilterQueryHookResult = ReturnType<typeof usePdpPlanFilterQuery>;
export type PdpPlanFilterLazyQueryHookResult = ReturnType<typeof usePdpPlanFilterLazyQuery>;
export type PdpPlanFilterSuspenseQueryHookResult = ReturnType<typeof usePdpPlanFilterSuspenseQuery>;
export type PdpPlanFilterQueryResult = Apollo.QueryResult<PdpPlanFilterQuery, PdpPlanFilterQueryVariables>;
export const PdpStarRatingsDocument = gql`
    query pdpStarRatings($filter: PdpPlansFilterInput!) {
  pdpStarRatings(filter: $filter) {
    count
    key
    name
  }
}
    `;

/**
 * __usePdpStarRatingsQuery__
 *
 * To run a query within a React component, call `usePdpStarRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpStarRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpStarRatingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePdpStarRatingsQuery(baseOptions: Apollo.QueryHookOptions<PdpStarRatingsQuery, PdpStarRatingsQueryVariables> & ({ variables: PdpStarRatingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpStarRatingsQuery, PdpStarRatingsQueryVariables>(PdpStarRatingsDocument, options);
      }
export function usePdpStarRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpStarRatingsQuery, PdpStarRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpStarRatingsQuery, PdpStarRatingsQueryVariables>(PdpStarRatingsDocument, options);
        }
export function usePdpStarRatingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpStarRatingsQuery, PdpStarRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpStarRatingsQuery, PdpStarRatingsQueryVariables>(PdpStarRatingsDocument, options);
        }
export type PdpStarRatingsQueryHookResult = ReturnType<typeof usePdpStarRatingsQuery>;
export type PdpStarRatingsLazyQueryHookResult = ReturnType<typeof usePdpStarRatingsLazyQuery>;
export type PdpStarRatingsSuspenseQueryHookResult = ReturnType<typeof usePdpStarRatingsSuspenseQuery>;
export type PdpStarRatingsQueryResult = Apollo.QueryResult<PdpStarRatingsQuery, PdpStarRatingsQueryVariables>;
export const MedicarePlanDocument = gql`
    query medicarePlan($bidId: String!, $zip: String!, $countyName: String!, $quoteId: UUID, $fullYear: Boolean, $planYear: PlanYear) {
  plan(
    bidId: $bidId
    zip: $zip
    quoteId: $quoteId
    countyName: $countyName
    fullYear: $fullYear
    planYear: $planYear
  ) {
    ...MaPlanFields
    prescriptionDrugDeductible @client
    prescriptionDrugDeductibleShort @client
  }
}
    ${MaPlanFieldsFragmentDoc}`;

/**
 * __useMedicarePlanQuery__
 *
 * To run a query within a React component, call `useMedicarePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicarePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicarePlanQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *      zip: // value for 'zip'
 *      countyName: // value for 'countyName'
 *      quoteId: // value for 'quoteId'
 *      fullYear: // value for 'fullYear'
 *      planYear: // value for 'planYear'
 *   },
 * });
 */
export function useMedicarePlanQuery(baseOptions: Apollo.QueryHookOptions<MedicarePlanQuery, MedicarePlanQueryVariables> & ({ variables: MedicarePlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicarePlanQuery, MedicarePlanQueryVariables>(MedicarePlanDocument, options);
      }
export function useMedicarePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicarePlanQuery, MedicarePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicarePlanQuery, MedicarePlanQueryVariables>(MedicarePlanDocument, options);
        }
export function useMedicarePlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedicarePlanQuery, MedicarePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicarePlanQuery, MedicarePlanQueryVariables>(MedicarePlanDocument, options);
        }
export type MedicarePlanQueryHookResult = ReturnType<typeof useMedicarePlanQuery>;
export type MedicarePlanLazyQueryHookResult = ReturnType<typeof useMedicarePlanLazyQuery>;
export type MedicarePlanSuspenseQueryHookResult = ReturnType<typeof useMedicarePlanSuspenseQuery>;
export type MedicarePlanQueryResult = Apollo.QueryResult<MedicarePlanQuery, MedicarePlanQueryVariables>;
export const PackageDescriptionByRxcuiDocument = gql`
    query packageDescriptionByRxcui($rxcui: String!) {
  packageDescriptionByRxcui(rxcui: $rxcui) {
    packageDescription
    unitType
  }
}
    `;

/**
 * __usePackageDescriptionByRxcuiQuery__
 *
 * To run a query within a React component, call `usePackageDescriptionByRxcuiQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageDescriptionByRxcuiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageDescriptionByRxcuiQuery({
 *   variables: {
 *      rxcui: // value for 'rxcui'
 *   },
 * });
 */
export function usePackageDescriptionByRxcuiQuery(baseOptions: Apollo.QueryHookOptions<PackageDescriptionByRxcuiQuery, PackageDescriptionByRxcuiQueryVariables> & ({ variables: PackageDescriptionByRxcuiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageDescriptionByRxcuiQuery, PackageDescriptionByRxcuiQueryVariables>(PackageDescriptionByRxcuiDocument, options);
      }
export function usePackageDescriptionByRxcuiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageDescriptionByRxcuiQuery, PackageDescriptionByRxcuiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageDescriptionByRxcuiQuery, PackageDescriptionByRxcuiQueryVariables>(PackageDescriptionByRxcuiDocument, options);
        }
export function usePackageDescriptionByRxcuiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PackageDescriptionByRxcuiQuery, PackageDescriptionByRxcuiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PackageDescriptionByRxcuiQuery, PackageDescriptionByRxcuiQueryVariables>(PackageDescriptionByRxcuiDocument, options);
        }
export type PackageDescriptionByRxcuiQueryHookResult = ReturnType<typeof usePackageDescriptionByRxcuiQuery>;
export type PackageDescriptionByRxcuiLazyQueryHookResult = ReturnType<typeof usePackageDescriptionByRxcuiLazyQuery>;
export type PackageDescriptionByRxcuiSuspenseQueryHookResult = ReturnType<typeof usePackageDescriptionByRxcuiSuspenseQuery>;
export type PackageDescriptionByRxcuiQueryResult = Apollo.QueryResult<PackageDescriptionByRxcuiQuery, PackageDescriptionByRxcuiQueryVariables>;
export const SaveEnabledPdpContractDocument = gql`
    mutation saveEnabledPdpContract($input: EnabledPdpContractInput!) {
  saveEnabledPdpContract(input: $input)
}
    `;
export type SaveEnabledPdpContractMutationFn = Apollo.MutationFunction<SaveEnabledPdpContractMutation, SaveEnabledPdpContractMutationVariables>;

/**
 * __useSaveEnabledPdpContractMutation__
 *
 * To run a mutation, you first call `useSaveEnabledPdpContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEnabledPdpContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEnabledPdpContractMutation, { data, loading, error }] = useSaveEnabledPdpContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEnabledPdpContractMutation(baseOptions?: Apollo.MutationHookOptions<SaveEnabledPdpContractMutation, SaveEnabledPdpContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEnabledPdpContractMutation, SaveEnabledPdpContractMutationVariables>(SaveEnabledPdpContractDocument, options);
      }
export type SaveEnabledPdpContractMutationHookResult = ReturnType<typeof useSaveEnabledPdpContractMutation>;
export type SaveEnabledPdpContractMutationResult = Apollo.MutationResult<SaveEnabledPdpContractMutation>;
export type SaveEnabledPdpContractMutationOptions = Apollo.BaseMutationOptions<SaveEnabledPdpContractMutation, SaveEnabledPdpContractMutationVariables>;
export const MedicareFilterCompaniesDocument = gql`
    query medicareFilterCompanies($filter: PlansFilterInput!) {
  companies(filter: $filter) {
    key
    name
    count
  }
}
    `;

/**
 * __useMedicareFilterCompaniesQuery__
 *
 * To run a query within a React component, call `useMedicareFilterCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicareFilterCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicareFilterCompaniesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMedicareFilterCompaniesQuery(baseOptions: Apollo.QueryHookOptions<MedicareFilterCompaniesQuery, MedicareFilterCompaniesQueryVariables> & ({ variables: MedicareFilterCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicareFilterCompaniesQuery, MedicareFilterCompaniesQueryVariables>(MedicareFilterCompaniesDocument, options);
      }
export function useMedicareFilterCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicareFilterCompaniesQuery, MedicareFilterCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicareFilterCompaniesQuery, MedicareFilterCompaniesQueryVariables>(MedicareFilterCompaniesDocument, options);
        }
export function useMedicareFilterCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedicareFilterCompaniesQuery, MedicareFilterCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicareFilterCompaniesQuery, MedicareFilterCompaniesQueryVariables>(MedicareFilterCompaniesDocument, options);
        }
export type MedicareFilterCompaniesQueryHookResult = ReturnType<typeof useMedicareFilterCompaniesQuery>;
export type MedicareFilterCompaniesLazyQueryHookResult = ReturnType<typeof useMedicareFilterCompaniesLazyQuery>;
export type MedicareFilterCompaniesSuspenseQueryHookResult = ReturnType<typeof useMedicareFilterCompaniesSuspenseQuery>;
export type MedicareFilterCompaniesQueryResult = Apollo.QueryResult<MedicareFilterCompaniesQuery, MedicareFilterCompaniesQueryVariables>;
export const SaveEnabledMaContractDocument = gql`
    mutation saveEnabledMaContract($input: EnabledPbpContractInput!) {
  saveEnabledPbpContract(input: $input)
}
    `;
export type SaveEnabledMaContractMutationFn = Apollo.MutationFunction<SaveEnabledMaContractMutation, SaveEnabledMaContractMutationVariables>;

/**
 * __useSaveEnabledMaContractMutation__
 *
 * To run a mutation, you first call `useSaveEnabledMaContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEnabledMaContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEnabledMaContractMutation, { data, loading, error }] = useSaveEnabledMaContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEnabledMaContractMutation(baseOptions?: Apollo.MutationHookOptions<SaveEnabledMaContractMutation, SaveEnabledMaContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEnabledMaContractMutation, SaveEnabledMaContractMutationVariables>(SaveEnabledMaContractDocument, options);
      }
export type SaveEnabledMaContractMutationHookResult = ReturnType<typeof useSaveEnabledMaContractMutation>;
export type SaveEnabledMaContractMutationResult = Apollo.MutationResult<SaveEnabledMaContractMutation>;
export type SaveEnabledMaContractMutationOptions = Apollo.BaseMutationOptions<SaveEnabledMaContractMutation, SaveEnabledMaContractMutationVariables>;
export const EnabledMaContractsDocument = gql`
    query enabledMaContracts {
  enabledPbpContracts {
    company
    contract
    enabled
    parentCompany
  }
}
    `;

/**
 * __useEnabledMaContractsQuery__
 *
 * To run a query within a React component, call `useEnabledMaContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledMaContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledMaContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledMaContractsQuery(baseOptions?: Apollo.QueryHookOptions<EnabledMaContractsQuery, EnabledMaContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnabledMaContractsQuery, EnabledMaContractsQueryVariables>(EnabledMaContractsDocument, options);
      }
export function useEnabledMaContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnabledMaContractsQuery, EnabledMaContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnabledMaContractsQuery, EnabledMaContractsQueryVariables>(EnabledMaContractsDocument, options);
        }
export function useEnabledMaContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnabledMaContractsQuery, EnabledMaContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnabledMaContractsQuery, EnabledMaContractsQueryVariables>(EnabledMaContractsDocument, options);
        }
export type EnabledMaContractsQueryHookResult = ReturnType<typeof useEnabledMaContractsQuery>;
export type EnabledMaContractsLazyQueryHookResult = ReturnType<typeof useEnabledMaContractsLazyQuery>;
export type EnabledMaContractsSuspenseQueryHookResult = ReturnType<typeof useEnabledMaContractsSuspenseQuery>;
export type EnabledMaContractsQueryResult = Apollo.QueryResult<EnabledMaContractsQuery, EnabledMaContractsQueryVariables>;
export const EnabledPdpContractsDocument = gql`
    query enabledPdpContracts {
  enabledPdpContracts {
    company
    contract
    enabled
    parentCompany
  }
}
    `;

/**
 * __useEnabledPdpContractsQuery__
 *
 * To run a query within a React component, call `useEnabledPdpContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledPdpContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledPdpContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledPdpContractsQuery(baseOptions?: Apollo.QueryHookOptions<EnabledPdpContractsQuery, EnabledPdpContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnabledPdpContractsQuery, EnabledPdpContractsQueryVariables>(EnabledPdpContractsDocument, options);
      }
export function useEnabledPdpContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnabledPdpContractsQuery, EnabledPdpContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnabledPdpContractsQuery, EnabledPdpContractsQueryVariables>(EnabledPdpContractsDocument, options);
        }
export function useEnabledPdpContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnabledPdpContractsQuery, EnabledPdpContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnabledPdpContractsQuery, EnabledPdpContractsQueryVariables>(EnabledPdpContractsDocument, options);
        }
export type EnabledPdpContractsQueryHookResult = ReturnType<typeof useEnabledPdpContractsQuery>;
export type EnabledPdpContractsLazyQueryHookResult = ReturnType<typeof useEnabledPdpContractsLazyQuery>;
export type EnabledPdpContractsSuspenseQueryHookResult = ReturnType<typeof useEnabledPdpContractsSuspenseQuery>;
export type EnabledPdpContractsQueryResult = Apollo.QueryResult<EnabledPdpContractsQuery, EnabledPdpContractsQueryVariables>;
export const ManuallyUploadedPlanFilesDocument = gql`
    query manuallyUploadedPlanFiles($page: PageInput!, $filter: PlanFileFilterInput) {
  manuallyUploadedPlanFiles(page: $page, filter: $filter) {
    totalPages
    totalElements
    data {
      bidId
      evidenceOfCoverageDocUrl
      nondiscriminationNoticeDocUrl
      preEnrollmentChecklistDocUrl
      starRatingDescDocUrl
      summaryOfBenefitsUrl
      planYear
      orgName
      parentOrgName
      planName
      zip
    }
  }
}
    `;

/**
 * __useManuallyUploadedPlanFilesQuery__
 *
 * To run a query within a React component, call `useManuallyUploadedPlanFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManuallyUploadedPlanFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManuallyUploadedPlanFilesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useManuallyUploadedPlanFilesQuery(baseOptions: Apollo.QueryHookOptions<ManuallyUploadedPlanFilesQuery, ManuallyUploadedPlanFilesQueryVariables> & ({ variables: ManuallyUploadedPlanFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManuallyUploadedPlanFilesQuery, ManuallyUploadedPlanFilesQueryVariables>(ManuallyUploadedPlanFilesDocument, options);
      }
export function useManuallyUploadedPlanFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManuallyUploadedPlanFilesQuery, ManuallyUploadedPlanFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManuallyUploadedPlanFilesQuery, ManuallyUploadedPlanFilesQueryVariables>(ManuallyUploadedPlanFilesDocument, options);
        }
export function useManuallyUploadedPlanFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManuallyUploadedPlanFilesQuery, ManuallyUploadedPlanFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManuallyUploadedPlanFilesQuery, ManuallyUploadedPlanFilesQueryVariables>(ManuallyUploadedPlanFilesDocument, options);
        }
export type ManuallyUploadedPlanFilesQueryHookResult = ReturnType<typeof useManuallyUploadedPlanFilesQuery>;
export type ManuallyUploadedPlanFilesLazyQueryHookResult = ReturnType<typeof useManuallyUploadedPlanFilesLazyQuery>;
export type ManuallyUploadedPlanFilesSuspenseQueryHookResult = ReturnType<typeof useManuallyUploadedPlanFilesSuspenseQuery>;
export type ManuallyUploadedPlanFilesQueryResult = Apollo.QueryResult<ManuallyUploadedPlanFilesQuery, ManuallyUploadedPlanFilesQueryVariables>;
export const AdminMaPlansDocument = gql`
    query adminMaPlans($filter: PlansFilterInput!, $snpFilter: PlansFilterInput!, $page: PageInput!, $sort: [PlansSortInput!]!, $quoteId: UUID) {
  plans(filter: $filter, page: $page, quoteId: $quoteId, sort: $sort) {
    data {
      planName
      planType
      bidId
      orgName
      parentOrgName
      planYear
    }
    totalElements
  }
  snpPlans: plans(filter: $snpFilter, page: $page, quoteId: $quoteId, sort: $sort) {
    data {
      planName
      planType
      bidId
      orgName
      parentOrgName
      planYear
    }
    totalElements
  }
}
    `;

/**
 * __useAdminMaPlansQuery__
 *
 * To run a query within a React component, call `useAdminMaPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMaPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMaPlansQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      snpFilter: // value for 'snpFilter'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useAdminMaPlansQuery(baseOptions: Apollo.QueryHookOptions<AdminMaPlansQuery, AdminMaPlansQueryVariables> & ({ variables: AdminMaPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMaPlansQuery, AdminMaPlansQueryVariables>(AdminMaPlansDocument, options);
      }
export function useAdminMaPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMaPlansQuery, AdminMaPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMaPlansQuery, AdminMaPlansQueryVariables>(AdminMaPlansDocument, options);
        }
export function useAdminMaPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminMaPlansQuery, AdminMaPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminMaPlansQuery, AdminMaPlansQueryVariables>(AdminMaPlansDocument, options);
        }
export type AdminMaPlansQueryHookResult = ReturnType<typeof useAdminMaPlansQuery>;
export type AdminMaPlansLazyQueryHookResult = ReturnType<typeof useAdminMaPlansLazyQuery>;
export type AdminMaPlansSuspenseQueryHookResult = ReturnType<typeof useAdminMaPlansSuspenseQuery>;
export type AdminMaPlansQueryResult = Apollo.QueryResult<AdminMaPlansQuery, AdminMaPlansQueryVariables>;
export const MaCompaniesDocument = gql`
    query maCompanies($filter: PlansFilterInput!, $snpFilter: PlansFilterInput!) {
  companies(filter: $filter) {
    name
    key
    count
  }
  snpCompanies: companies(filter: $snpFilter) {
    name
    key
    count
  }
}
    `;

/**
 * __useMaCompaniesQuery__
 *
 * To run a query within a React component, call `useMaCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaCompaniesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      snpFilter: // value for 'snpFilter'
 *   },
 * });
 */
export function useMaCompaniesQuery(baseOptions: Apollo.QueryHookOptions<MaCompaniesQuery, MaCompaniesQueryVariables> & ({ variables: MaCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaCompaniesQuery, MaCompaniesQueryVariables>(MaCompaniesDocument, options);
      }
export function useMaCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaCompaniesQuery, MaCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaCompaniesQuery, MaCompaniesQueryVariables>(MaCompaniesDocument, options);
        }
export function useMaCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaCompaniesQuery, MaCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaCompaniesQuery, MaCompaniesQueryVariables>(MaCompaniesDocument, options);
        }
export type MaCompaniesQueryHookResult = ReturnType<typeof useMaCompaniesQuery>;
export type MaCompaniesLazyQueryHookResult = ReturnType<typeof useMaCompaniesLazyQuery>;
export type MaCompaniesSuspenseQueryHookResult = ReturnType<typeof useMaCompaniesSuspenseQuery>;
export type MaCompaniesQueryResult = Apollo.QueryResult<MaCompaniesQuery, MaCompaniesQueryVariables>;
export const CreateMedicareQuoteForClientDocument = gql`
    mutation createMedicareQuoteForClient($data: MedicareQuoteInput!) {
  createMedicareQuoteForClient(data: $data) {
    clientId
    maQuoteID
  }
}
    `;
export type CreateMedicareQuoteForClientMutationFn = Apollo.MutationFunction<CreateMedicareQuoteForClientMutation, CreateMedicareQuoteForClientMutationVariables>;

/**
 * __useCreateMedicareQuoteForClientMutation__
 *
 * To run a mutation, you first call `useCreateMedicareQuoteForClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicareQuoteForClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicareQuoteForClientMutation, { data, loading, error }] = useCreateMedicareQuoteForClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMedicareQuoteForClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicareQuoteForClientMutation, CreateMedicareQuoteForClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedicareQuoteForClientMutation, CreateMedicareQuoteForClientMutationVariables>(CreateMedicareQuoteForClientDocument, options);
      }
export type CreateMedicareQuoteForClientMutationHookResult = ReturnType<typeof useCreateMedicareQuoteForClientMutation>;
export type CreateMedicareQuoteForClientMutationResult = Apollo.MutationResult<CreateMedicareQuoteForClientMutation>;
export type CreateMedicareQuoteForClientMutationOptions = Apollo.BaseMutationOptions<CreateMedicareQuoteForClientMutation, CreateMedicareQuoteForClientMutationVariables>;
export const PdpPlansTotalDocument = gql`
    query pdpPlansTotal {
  pdpPlansTotal @client
}
    `;

/**
 * __usePdpPlansTotalQuery__
 *
 * To run a query within a React component, call `usePdpPlansTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlansTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlansTotalQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdpPlansTotalQuery(baseOptions?: Apollo.QueryHookOptions<PdpPlansTotalQuery, PdpPlansTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlansTotalQuery, PdpPlansTotalQueryVariables>(PdpPlansTotalDocument, options);
      }
export function usePdpPlansTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlansTotalQuery, PdpPlansTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlansTotalQuery, PdpPlansTotalQueryVariables>(PdpPlansTotalDocument, options);
        }
export function usePdpPlansTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlansTotalQuery, PdpPlansTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlansTotalQuery, PdpPlansTotalQueryVariables>(PdpPlansTotalDocument, options);
        }
export type PdpPlansTotalQueryHookResult = ReturnType<typeof usePdpPlansTotalQuery>;
export type PdpPlansTotalLazyQueryHookResult = ReturnType<typeof usePdpPlansTotalLazyQuery>;
export type PdpPlansTotalSuspenseQueryHookResult = ReturnType<typeof usePdpPlansTotalSuspenseQuery>;
export type PdpPlansTotalQueryResult = Apollo.QueryResult<PdpPlansTotalQuery, PdpPlansTotalQueryVariables>;
export const PdpPlansSortDocument = gql`
    query pdpPlansSort {
  pdpPlansSort @client
}
    `;

/**
 * __usePdpPlansSortQuery__
 *
 * To run a query within a React component, call `usePdpPlansSortQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlansSortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlansSortQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdpPlansSortQuery(baseOptions?: Apollo.QueryHookOptions<PdpPlansSortQuery, PdpPlansSortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlansSortQuery, PdpPlansSortQueryVariables>(PdpPlansSortDocument, options);
      }
export function usePdpPlansSortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlansSortQuery, PdpPlansSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlansSortQuery, PdpPlansSortQueryVariables>(PdpPlansSortDocument, options);
        }
export function usePdpPlansSortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlansSortQuery, PdpPlansSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlansSortQuery, PdpPlansSortQueryVariables>(PdpPlansSortDocument, options);
        }
export type PdpPlansSortQueryHookResult = ReturnType<typeof usePdpPlansSortQuery>;
export type PdpPlansSortLazyQueryHookResult = ReturnType<typeof usePdpPlansSortLazyQuery>;
export type PdpPlansSortSuspenseQueryHookResult = ReturnType<typeof usePdpPlansSortSuspenseQuery>;
export type PdpPlansSortQueryResult = Apollo.QueryResult<PdpPlansSortQuery, PdpPlansSortQueryVariables>;
export const PdpPlanYearDocument = gql`
    query pdpPlanYear {
  pdpPlanYear @client
}
    `;

/**
 * __usePdpPlanYearQuery__
 *
 * To run a query within a React component, call `usePdpPlanYearQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlanYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlanYearQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdpPlanYearQuery(baseOptions?: Apollo.QueryHookOptions<PdpPlanYearQuery, PdpPlanYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlanYearQuery, PdpPlanYearQueryVariables>(PdpPlanYearDocument, options);
      }
export function usePdpPlanYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlanYearQuery, PdpPlanYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlanYearQuery, PdpPlanYearQueryVariables>(PdpPlanYearDocument, options);
        }
export function usePdpPlanYearSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlanYearQuery, PdpPlanYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlanYearQuery, PdpPlanYearQueryVariables>(PdpPlanYearDocument, options);
        }
export type PdpPlanYearQueryHookResult = ReturnType<typeof usePdpPlanYearQuery>;
export type PdpPlanYearLazyQueryHookResult = ReturnType<typeof usePdpPlanYearLazyQuery>;
export type PdpPlanYearSuspenseQueryHookResult = ReturnType<typeof usePdpPlanYearSuspenseQuery>;
export type PdpPlanYearQueryResult = Apollo.QueryResult<PdpPlanYearQuery, PdpPlanYearQueryVariables>;
export const PdpFiltersDocument = gql`
    query pdpFilters {
  pdpFilters @client {
    companies
    rating
  }
}
    `;

/**
 * __usePdpFiltersQuery__
 *
 * To run a query within a React component, call `usePdpFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdpFiltersQuery(baseOptions?: Apollo.QueryHookOptions<PdpFiltersQuery, PdpFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpFiltersQuery, PdpFiltersQueryVariables>(PdpFiltersDocument, options);
      }
export function usePdpFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpFiltersQuery, PdpFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpFiltersQuery, PdpFiltersQueryVariables>(PdpFiltersDocument, options);
        }
export function usePdpFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpFiltersQuery, PdpFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpFiltersQuery, PdpFiltersQueryVariables>(PdpFiltersDocument, options);
        }
export type PdpFiltersQueryHookResult = ReturnType<typeof usePdpFiltersQuery>;
export type PdpFiltersLazyQueryHookResult = ReturnType<typeof usePdpFiltersLazyQuery>;
export type PdpFiltersSuspenseQueryHookResult = ReturnType<typeof usePdpFiltersSuspenseQuery>;
export type PdpFiltersQueryResult = Apollo.QueryResult<PdpFiltersQuery, PdpFiltersQueryVariables>;
export const MaPlansSortDocument = gql`
    query maPlansSort {
  maPlansSort @client
}
    `;

/**
 * __useMaPlansSortQuery__
 *
 * To run a query within a React component, call `useMaPlansSortQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaPlansSortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaPlansSortQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaPlansSortQuery(baseOptions?: Apollo.QueryHookOptions<MaPlansSortQuery, MaPlansSortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaPlansSortQuery, MaPlansSortQueryVariables>(MaPlansSortDocument, options);
      }
export function useMaPlansSortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaPlansSortQuery, MaPlansSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaPlansSortQuery, MaPlansSortQueryVariables>(MaPlansSortDocument, options);
        }
export function useMaPlansSortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaPlansSortQuery, MaPlansSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaPlansSortQuery, MaPlansSortQueryVariables>(MaPlansSortDocument, options);
        }
export type MaPlansSortQueryHookResult = ReturnType<typeof useMaPlansSortQuery>;
export type MaPlansSortLazyQueryHookResult = ReturnType<typeof useMaPlansSortLazyQuery>;
export type MaPlansSortSuspenseQueryHookResult = ReturnType<typeof useMaPlansSortSuspenseQuery>;
export type MaPlansSortQueryResult = Apollo.QueryResult<MaPlansSortQuery, MaPlansSortQueryVariables>;
export const MaPlansInfoDocument = gql`
    query maPlansInfo {
  maPlansInfo {
    doctorsCheckBoxMessage @client
    drugsCheckBoxMessage @client
    totalElements @client
  }
}
    `;

/**
 * __useMaPlansInfoQuery__
 *
 * To run a query within a React component, call `useMaPlansInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaPlansInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaPlansInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaPlansInfoQuery(baseOptions?: Apollo.QueryHookOptions<MaPlansInfoQuery, MaPlansInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaPlansInfoQuery, MaPlansInfoQueryVariables>(MaPlansInfoDocument, options);
      }
export function useMaPlansInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaPlansInfoQuery, MaPlansInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaPlansInfoQuery, MaPlansInfoQueryVariables>(MaPlansInfoDocument, options);
        }
export function useMaPlansInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaPlansInfoQuery, MaPlansInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaPlansInfoQuery, MaPlansInfoQueryVariables>(MaPlansInfoDocument, options);
        }
export type MaPlansInfoQueryHookResult = ReturnType<typeof useMaPlansInfoQuery>;
export type MaPlansInfoLazyQueryHookResult = ReturnType<typeof useMaPlansInfoLazyQuery>;
export type MaPlansInfoSuspenseQueryHookResult = ReturnType<typeof useMaPlansInfoSuspenseQuery>;
export type MaPlansInfoQueryResult = Apollo.QueryResult<MaPlansInfoQuery, MaPlansInfoQueryVariables>;
export const CreatePdpQuoteForClientDocument = gql`
    mutation createPdpQuoteForClient($userId: UUID, $input: PdpQuoteInput!) {
  createPdpQuoteForClient(input: $input, userId: $userId) {
    cId
    clientId
    countyName
    drugDeliveryType
    id
    insulinSavings
    preferredPharmacies
    zip
  }
}
    `;
export type CreatePdpQuoteForClientMutationFn = Apollo.MutationFunction<CreatePdpQuoteForClientMutation, CreatePdpQuoteForClientMutationVariables>;

/**
 * __useCreatePdpQuoteForClientMutation__
 *
 * To run a mutation, you first call `useCreatePdpQuoteForClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePdpQuoteForClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPdpQuoteForClientMutation, { data, loading, error }] = useCreatePdpQuoteForClientMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePdpQuoteForClientMutation(baseOptions?: Apollo.MutationHookOptions<CreatePdpQuoteForClientMutation, CreatePdpQuoteForClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePdpQuoteForClientMutation, CreatePdpQuoteForClientMutationVariables>(CreatePdpQuoteForClientDocument, options);
      }
export type CreatePdpQuoteForClientMutationHookResult = ReturnType<typeof useCreatePdpQuoteForClientMutation>;
export type CreatePdpQuoteForClientMutationResult = Apollo.MutationResult<CreatePdpQuoteForClientMutation>;
export type CreatePdpQuoteForClientMutationOptions = Apollo.BaseMutationOptions<CreatePdpQuoteForClientMutation, CreatePdpQuoteForClientMutationVariables>;
export const PlansByIdsDocument = gql`
    query plansByIds($plans: [PlanInput!]!, $quoteId: UUID) {
  plansByIds(plans: $plans, quoteId: $quoteId) {
    ...MaPlanFields
    prescriptionDrugDeductible @client
    prescriptionDrugDeductibleShort @client
  }
}
    ${MaPlanFieldsFragmentDoc}`;

/**
 * __usePlansByIdsQuery__
 *
 * To run a query within a React component, call `usePlansByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansByIdsQuery({
 *   variables: {
 *      plans: // value for 'plans'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function usePlansByIdsQuery(baseOptions: Apollo.QueryHookOptions<PlansByIdsQuery, PlansByIdsQueryVariables> & ({ variables: PlansByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlansByIdsQuery, PlansByIdsQueryVariables>(PlansByIdsDocument, options);
      }
export function usePlansByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansByIdsQuery, PlansByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlansByIdsQuery, PlansByIdsQueryVariables>(PlansByIdsDocument, options);
        }
export function usePlansByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlansByIdsQuery, PlansByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlansByIdsQuery, PlansByIdsQueryVariables>(PlansByIdsDocument, options);
        }
export type PlansByIdsQueryHookResult = ReturnType<typeof usePlansByIdsQuery>;
export type PlansByIdsLazyQueryHookResult = ReturnType<typeof usePlansByIdsLazyQuery>;
export type PlansByIdsSuspenseQueryHookResult = ReturnType<typeof usePlansByIdsSuspenseQuery>;
export type PlansByIdsQueryResult = Apollo.QueryResult<PlansByIdsQuery, PlansByIdsQueryVariables>;
export const SavePdpQuoteDocument = gql`
    mutation savePdpQuote($input: PdpQuoteInput!, $userId: UUID) {
  savePdpQuote(input: $input, userId: $userId) {
    cId
    clientId
    countyName
    id
    insulinSavings
    zip
  }
}
    `;
export type SavePdpQuoteMutationFn = Apollo.MutationFunction<SavePdpQuoteMutation, SavePdpQuoteMutationVariables>;

/**
 * __useSavePdpQuoteMutation__
 *
 * To run a mutation, you first call `useSavePdpQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePdpQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePdpQuoteMutation, { data, loading, error }] = useSavePdpQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSavePdpQuoteMutation(baseOptions?: Apollo.MutationHookOptions<SavePdpQuoteMutation, SavePdpQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePdpQuoteMutation, SavePdpQuoteMutationVariables>(SavePdpQuoteDocument, options);
      }
export type SavePdpQuoteMutationHookResult = ReturnType<typeof useSavePdpQuoteMutation>;
export type SavePdpQuoteMutationResult = Apollo.MutationResult<SavePdpQuoteMutation>;
export type SavePdpQuoteMutationOptions = Apollo.BaseMutationOptions<SavePdpQuoteMutation, SavePdpQuoteMutationVariables>;
export const PdpQuoteDocument = gql`
    query pdpQuote($id: UUID!) {
  pdpQuote(id: $id) {
    cId
    clientId
    countyName
    id
    insulinSavings
    zip
    drugDeliveryType
    preferredDrugs {
      dosageRxcui
      frequency
      productRxcui
      purchaseFrequency
      quantity
    }
    preferredPharmacies
  }
}
    `;

/**
 * __usePdpQuoteQuery__
 *
 * To run a query within a React component, call `usePdpQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePdpQuoteQuery(baseOptions: Apollo.QueryHookOptions<PdpQuoteQuery, PdpQuoteQueryVariables> & ({ variables: PdpQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpQuoteQuery, PdpQuoteQueryVariables>(PdpQuoteDocument, options);
      }
export function usePdpQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpQuoteQuery, PdpQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpQuoteQuery, PdpQuoteQueryVariables>(PdpQuoteDocument, options);
        }
export function usePdpQuoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpQuoteQuery, PdpQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpQuoteQuery, PdpQuoteQueryVariables>(PdpQuoteDocument, options);
        }
export type PdpQuoteQueryHookResult = ReturnType<typeof usePdpQuoteQuery>;
export type PdpQuoteLazyQueryHookResult = ReturnType<typeof usePdpQuoteLazyQuery>;
export type PdpQuoteSuspenseQueryHookResult = ReturnType<typeof usePdpQuoteSuspenseQuery>;
export type PdpQuoteQueryResult = Apollo.QueryResult<PdpQuoteQuery, PdpQuoteQueryVariables>;
export const PdpPlanDocument = gql`
    query pdpPlan($bidId: String!, $clientId: UUID, $countyName: String!, $fullYear: Boolean, $planYear: PlanYear, $zip: String!) {
  PdpPlan(
    fullYear: $fullYear
    clientId: $clientId
    bidId: $bidId
    zip: $zip
    countyName: $countyName
    planYear: $planYear
  ) {
    ...PdpPlanFields
  }
}
    ${PdpPlanFieldsFragmentDoc}`;

/**
 * __usePdpPlanQuery__
 *
 * To run a query within a React component, call `usePdpPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlanQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *      clientId: // value for 'clientId'
 *      countyName: // value for 'countyName'
 *      fullYear: // value for 'fullYear'
 *      planYear: // value for 'planYear'
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function usePdpPlanQuery(baseOptions: Apollo.QueryHookOptions<PdpPlanQuery, PdpPlanQueryVariables> & ({ variables: PdpPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlanQuery, PdpPlanQueryVariables>(PdpPlanDocument, options);
      }
export function usePdpPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlanQuery, PdpPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlanQuery, PdpPlanQueryVariables>(PdpPlanDocument, options);
        }
export function usePdpPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlanQuery, PdpPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlanQuery, PdpPlanQueryVariables>(PdpPlanDocument, options);
        }
export type PdpPlanQueryHookResult = ReturnType<typeof usePdpPlanQuery>;
export type PdpPlanLazyQueryHookResult = ReturnType<typeof usePdpPlanLazyQuery>;
export type PdpPlanSuspenseQueryHookResult = ReturnType<typeof usePdpPlanSuspenseQuery>;
export type PdpPlanQueryResult = Apollo.QueryResult<PdpPlanQuery, PdpPlanQueryVariables>;
export const PdpPlanListDocument = gql`
    query pdpPlanList($filter: PdpPlansFilterInput!, $page: PageInput!, $fullYear: Boolean, $sort: [PdpPlansSortInput!]!, $clientId: UUID) {
  PdpPlans(
    filter: $filter
    page: $page
    sort: $sort
    fullYear: $fullYear
    clientId: $clientId
  ) {
    data {
      ...PdpPlanFields
    }
    totalElements
    hasNext
  }
}
    ${PdpPlanFieldsFragmentDoc}`;

/**
 * __usePdpPlanListQuery__
 *
 * To run a query within a React component, call `usePdpPlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlanListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      fullYear: // value for 'fullYear'
 *      sort: // value for 'sort'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function usePdpPlanListQuery(baseOptions: Apollo.QueryHookOptions<PdpPlanListQuery, PdpPlanListQueryVariables> & ({ variables: PdpPlanListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlanListQuery, PdpPlanListQueryVariables>(PdpPlanListDocument, options);
      }
export function usePdpPlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlanListQuery, PdpPlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlanListQuery, PdpPlanListQueryVariables>(PdpPlanListDocument, options);
        }
export function usePdpPlanListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlanListQuery, PdpPlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlanListQuery, PdpPlanListQueryVariables>(PdpPlanListDocument, options);
        }
export type PdpPlanListQueryHookResult = ReturnType<typeof usePdpPlanListQuery>;
export type PdpPlanListLazyQueryHookResult = ReturnType<typeof usePdpPlanListLazyQuery>;
export type PdpPlanListSuspenseQueryHookResult = ReturnType<typeof usePdpPlanListSuspenseQuery>;
export type PdpPlanListQueryResult = Apollo.QueryResult<PdpPlanListQuery, PdpPlanListQueryVariables>;
export const IsTherePlanWithFullDrugCoverageDocument = gql`
    query isTherePlanWithFullDrugCoverage($zip: String!, $countyName: String!, $quoteId: UUID, $planYear: PlanYear) {
  isTherePlanWithFullDrugCoverage(
    zip: $zip
    countyName: $countyName
    quoteId: $quoteId
    planYear: $planYear
  )
}
    `;

/**
 * __useIsTherePlanWithFullDrugCoverageQuery__
 *
 * To run a query within a React component, call `useIsTherePlanWithFullDrugCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsTherePlanWithFullDrugCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsTherePlanWithFullDrugCoverageQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *      countyName: // value for 'countyName'
 *      quoteId: // value for 'quoteId'
 *      planYear: // value for 'planYear'
 *   },
 * });
 */
export function useIsTherePlanWithFullDrugCoverageQuery(baseOptions: Apollo.QueryHookOptions<IsTherePlanWithFullDrugCoverageQuery, IsTherePlanWithFullDrugCoverageQueryVariables> & ({ variables: IsTherePlanWithFullDrugCoverageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsTherePlanWithFullDrugCoverageQuery, IsTherePlanWithFullDrugCoverageQueryVariables>(IsTherePlanWithFullDrugCoverageDocument, options);
      }
export function useIsTherePlanWithFullDrugCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsTherePlanWithFullDrugCoverageQuery, IsTherePlanWithFullDrugCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsTherePlanWithFullDrugCoverageQuery, IsTherePlanWithFullDrugCoverageQueryVariables>(IsTherePlanWithFullDrugCoverageDocument, options);
        }
export function useIsTherePlanWithFullDrugCoverageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsTherePlanWithFullDrugCoverageQuery, IsTherePlanWithFullDrugCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsTherePlanWithFullDrugCoverageQuery, IsTherePlanWithFullDrugCoverageQueryVariables>(IsTherePlanWithFullDrugCoverageDocument, options);
        }
export type IsTherePlanWithFullDrugCoverageQueryHookResult = ReturnType<typeof useIsTherePlanWithFullDrugCoverageQuery>;
export type IsTherePlanWithFullDrugCoverageLazyQueryHookResult = ReturnType<typeof useIsTherePlanWithFullDrugCoverageLazyQuery>;
export type IsTherePlanWithFullDrugCoverageSuspenseQueryHookResult = ReturnType<typeof useIsTherePlanWithFullDrugCoverageSuspenseQuery>;
export type IsTherePlanWithFullDrugCoverageQueryResult = Apollo.QueryResult<IsTherePlanWithFullDrugCoverageQuery, IsTherePlanWithFullDrugCoverageQueryVariables>;
export const IsPpoAvailableDocument = gql`
    query isPpoAvailable($filter: PlansFilterInput!) {
  planTypes(filter: $filter) {
    key
    name
    count
  }
}
    `;

/**
 * __useIsPpoAvailableQuery__
 *
 * To run a query within a React component, call `useIsPpoAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPpoAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPpoAvailableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIsPpoAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsPpoAvailableQuery, IsPpoAvailableQueryVariables> & ({ variables: IsPpoAvailableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPpoAvailableQuery, IsPpoAvailableQueryVariables>(IsPpoAvailableDocument, options);
      }
export function useIsPpoAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPpoAvailableQuery, IsPpoAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPpoAvailableQuery, IsPpoAvailableQueryVariables>(IsPpoAvailableDocument, options);
        }
export function useIsPpoAvailableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsPpoAvailableQuery, IsPpoAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsPpoAvailableQuery, IsPpoAvailableQueryVariables>(IsPpoAvailableDocument, options);
        }
export type IsPpoAvailableQueryHookResult = ReturnType<typeof useIsPpoAvailableQuery>;
export type IsPpoAvailableLazyQueryHookResult = ReturnType<typeof useIsPpoAvailableLazyQuery>;
export type IsPpoAvailableSuspenseQueryHookResult = ReturnType<typeof useIsPpoAvailableSuspenseQuery>;
export type IsPpoAvailableQueryResult = Apollo.QueryResult<IsPpoAvailableQuery, IsPpoAvailableQueryVariables>;
export const PlansCountByZipDocument = gql`
    query plansCountByZip($zip: String!) {
  plansCountByZip(zip: $zip) {
    maAndPdpPlansParentOrgCount
    maAndPdpPlansTotalParentOrgCount
    maPlansCount
    maPlansTotalCount
    maPlansParentOrgCount
    maPlansTotalParentOrgCount
    pdpPlansParentOrgCount
    pdpPlansTotalParentOrgCount
    pdpPlansCount
    pdpPlansTotalCount
    zip
  }
}
    `;

/**
 * __usePlansCountByZipQuery__
 *
 * To run a query within a React component, call `usePlansCountByZipQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansCountByZipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansCountByZipQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function usePlansCountByZipQuery(baseOptions: Apollo.QueryHookOptions<PlansCountByZipQuery, PlansCountByZipQueryVariables> & ({ variables: PlansCountByZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlansCountByZipQuery, PlansCountByZipQueryVariables>(PlansCountByZipDocument, options);
      }
export function usePlansCountByZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansCountByZipQuery, PlansCountByZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlansCountByZipQuery, PlansCountByZipQueryVariables>(PlansCountByZipDocument, options);
        }
export function usePlansCountByZipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlansCountByZipQuery, PlansCountByZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlansCountByZipQuery, PlansCountByZipQueryVariables>(PlansCountByZipDocument, options);
        }
export type PlansCountByZipQueryHookResult = ReturnType<typeof usePlansCountByZipQuery>;
export type PlansCountByZipLazyQueryHookResult = ReturnType<typeof usePlansCountByZipLazyQuery>;
export type PlansCountByZipSuspenseQueryHookResult = ReturnType<typeof usePlansCountByZipSuspenseQuery>;
export type PlansCountByZipQueryResult = Apollo.QueryResult<PlansCountByZipQuery, PlansCountByZipQueryVariables>;
export const MaPlanListDocument = gql`
    query maPlanList($filter: PlansFilterInput!, $page: PageInput!, $fullYear: Boolean, $sort: [PlansSortInput!]!, $quoteId: UUID) {
  plans(
    filter: $filter
    page: $page
    quoteId: $quoteId
    fullYear: $fullYear
    sort: $sort
  ) {
    data {
      ...MaPlanFields
      prescriptionDrugDeductible @client
      prescriptionDrugDeductibleShort @client
    }
    doctorsCheckBoxMessage
    drugsCheckBoxMessage
    totalElements
    number
    totalPages
    hasPrevious
    hasNext
  }
}
    ${MaPlanFieldsFragmentDoc}`;

/**
 * __useMaPlanListQuery__
 *
 * To run a query within a React component, call `useMaPlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaPlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaPlanListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      fullYear: // value for 'fullYear'
 *      sort: // value for 'sort'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useMaPlanListQuery(baseOptions: Apollo.QueryHookOptions<MaPlanListQuery, MaPlanListQueryVariables> & ({ variables: MaPlanListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaPlanListQuery, MaPlanListQueryVariables>(MaPlanListDocument, options);
      }
export function useMaPlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaPlanListQuery, MaPlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaPlanListQuery, MaPlanListQueryVariables>(MaPlanListDocument, options);
        }
export function useMaPlanListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaPlanListQuery, MaPlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaPlanListQuery, MaPlanListQueryVariables>(MaPlanListDocument, options);
        }
export type MaPlanListQueryHookResult = ReturnType<typeof useMaPlanListQuery>;
export type MaPlanListLazyQueryHookResult = ReturnType<typeof useMaPlanListLazyQuery>;
export type MaPlanListSuspenseQueryHookResult = ReturnType<typeof useMaPlanListSuspenseQuery>;
export type MaPlanListQueryResult = Apollo.QueryResult<MaPlanListQuery, MaPlanListQueryVariables>;
export const MaPlanFilterDocument = gql`
    query maPlanFilter($filters: PlansFilterInput!, $quoteId: UUID) {
  planTypes(filter: $filters) {
    key
    name
    count
  }
  companies(filter: $filters) {
    key
    name
    count
  }
  extraBenefits(filter: $filters) {
    key
    name
    count
  }
  SNPTypes(filter: $filters) {
    key
    name
    count
  }
  maxOutOfPocketRanges(filter: $filters) {
    key
    name
    count
  }
  maxCostRanges(filter: $filters, quoteId: $quoteId) {
    key
    name
    count
  }
  findStarRatings(filter: $filters) {
    key
    name
    count
  }
  partBPremiumReductionCount(filter: $filters)
}
    `;

/**
 * __useMaPlanFilterQuery__
 *
 * To run a query within a React component, call `useMaPlanFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaPlanFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaPlanFilterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useMaPlanFilterQuery(baseOptions: Apollo.QueryHookOptions<MaPlanFilterQuery, MaPlanFilterQueryVariables> & ({ variables: MaPlanFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaPlanFilterQuery, MaPlanFilterQueryVariables>(MaPlanFilterDocument, options);
      }
export function useMaPlanFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaPlanFilterQuery, MaPlanFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaPlanFilterQuery, MaPlanFilterQueryVariables>(MaPlanFilterDocument, options);
        }
export function useMaPlanFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaPlanFilterQuery, MaPlanFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaPlanFilterQuery, MaPlanFilterQueryVariables>(MaPlanFilterDocument, options);
        }
export type MaPlanFilterQueryHookResult = ReturnType<typeof useMaPlanFilterQuery>;
export type MaPlanFilterLazyQueryHookResult = ReturnType<typeof useMaPlanFilterLazyQuery>;
export type MaPlanFilterSuspenseQueryHookResult = ReturnType<typeof useMaPlanFilterSuspenseQuery>;
export type MaPlanFilterQueryResult = Apollo.QueryResult<MaPlanFilterQuery, MaPlanFilterQueryVariables>;
export const MedicareQuoteDocument = gql`
    query medicareQuote($id: UUID!) {
  medicareQuote(id: $id) {
    abCase
    createdAt
    county
    employed
    pin
    id
    clientId
    favorites
    restrictProviderNetwork
    travelMoreThan30DaysAYear
    doctorsWithinNetwork
    work8years
    filters {
      SNPTypes
      companies
      extraBenefits
      maxCostRangeNames
      maxOutOfPocketRangeNames
      partBPremiumReduction
      planTypes
      rating
      showTopDoctors
      showTopDrugs
    }
    planYear
    enrolled
    coverageFilled
    enrolledFilled
    drugDeliveryType
    hasMore20
    receivesMedicalSupport
    receivesLIS
    receivedBenefits
    governmentAssistant
    spouseEmployed
    spouseHasMore20
    zip
    doctorVisitsNumber
    specialistVisitsNumber
    coverage
    chronicIllness
    preferredPharmacies {
      address
      distance
      latitude
      longitude
      name
      npi
      zip
    }
    medicarePlanType
    prepayCoverage
    customAnswers
    preferredDrugs {
      ...Drug
    }
    preferredDoctors {
      npi
      addresses {
        addressLine1
        addressLine2
        id
        isPcp
        specialty
      }
      pcpDetails {
        id
        pcpId
        networkDetails {
          name
          carrierName
        }
      }
      name
      addressesNumber
    }
  }
}
    ${DrugFragmentDoc}`;

/**
 * __useMedicareQuoteQuery__
 *
 * To run a query within a React component, call `useMedicareQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicareQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicareQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicareQuoteQuery(baseOptions: Apollo.QueryHookOptions<MedicareQuoteQuery, MedicareQuoteQueryVariables> & ({ variables: MedicareQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicareQuoteQuery, MedicareQuoteQueryVariables>(MedicareQuoteDocument, options);
      }
export function useMedicareQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicareQuoteQuery, MedicareQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicareQuoteQuery, MedicareQuoteQueryVariables>(MedicareQuoteDocument, options);
        }
export function useMedicareQuoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedicareQuoteQuery, MedicareQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedicareQuoteQuery, MedicareQuoteQueryVariables>(MedicareQuoteDocument, options);
        }
export type MedicareQuoteQueryHookResult = ReturnType<typeof useMedicareQuoteQuery>;
export type MedicareQuoteLazyQueryHookResult = ReturnType<typeof useMedicareQuoteLazyQuery>;
export type MedicareQuoteSuspenseQueryHookResult = ReturnType<typeof useMedicareQuoteSuspenseQuery>;
export type MedicareQuoteQueryResult = Apollo.QueryResult<MedicareQuoteQuery, MedicareQuoteQueryVariables>;
export const SaveMedicareQuoteDocument = gql`
    mutation saveMedicareQuote($data: MedicareQuoteInput!) {
  saveMedicareQuote(data: $data) {
    maQuoteID
    clientId
  }
}
    `;
export type SaveMedicareQuoteMutationFn = Apollo.MutationFunction<SaveMedicareQuoteMutation, SaveMedicareQuoteMutationVariables>;

/**
 * __useSaveMedicareQuoteMutation__
 *
 * To run a mutation, you first call `useSaveMedicareQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMedicareQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMedicareQuoteMutation, { data, loading, error }] = useSaveMedicareQuoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveMedicareQuoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveMedicareQuoteMutation, SaveMedicareQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMedicareQuoteMutation, SaveMedicareQuoteMutationVariables>(SaveMedicareQuoteDocument, options);
      }
export type SaveMedicareQuoteMutationHookResult = ReturnType<typeof useSaveMedicareQuoteMutation>;
export type SaveMedicareQuoteMutationResult = Apollo.MutationResult<SaveMedicareQuoteMutation>;
export type SaveMedicareQuoteMutationOptions = Apollo.BaseMutationOptions<SaveMedicareQuoteMutation, SaveMedicareQuoteMutationVariables>;
export const FindProviderAddressesByNpiDocument = gql`
    query findProviderAddressesByNpi($npi: String!) {
  findProviderAddressesByNpi(npi: $npi) {
    addressLine1
    addressLine2
    id
    specialty
    isPcp
  }
}
    `;

/**
 * __useFindProviderAddressesByNpiQuery__
 *
 * To run a query within a React component, call `useFindProviderAddressesByNpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProviderAddressesByNpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProviderAddressesByNpiQuery({
 *   variables: {
 *      npi: // value for 'npi'
 *   },
 * });
 */
export function useFindProviderAddressesByNpiQuery(baseOptions: Apollo.QueryHookOptions<FindProviderAddressesByNpiQuery, FindProviderAddressesByNpiQueryVariables> & ({ variables: FindProviderAddressesByNpiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindProviderAddressesByNpiQuery, FindProviderAddressesByNpiQueryVariables>(FindProviderAddressesByNpiDocument, options);
      }
export function useFindProviderAddressesByNpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindProviderAddressesByNpiQuery, FindProviderAddressesByNpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindProviderAddressesByNpiQuery, FindProviderAddressesByNpiQueryVariables>(FindProviderAddressesByNpiDocument, options);
        }
export function useFindProviderAddressesByNpiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindProviderAddressesByNpiQuery, FindProviderAddressesByNpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindProviderAddressesByNpiQuery, FindProviderAddressesByNpiQueryVariables>(FindProviderAddressesByNpiDocument, options);
        }
export type FindProviderAddressesByNpiQueryHookResult = ReturnType<typeof useFindProviderAddressesByNpiQuery>;
export type FindProviderAddressesByNpiLazyQueryHookResult = ReturnType<typeof useFindProviderAddressesByNpiLazyQuery>;
export type FindProviderAddressesByNpiSuspenseQueryHookResult = ReturnType<typeof useFindProviderAddressesByNpiSuspenseQuery>;
export type FindProviderAddressesByNpiQueryResult = Apollo.QueryResult<FindProviderAddressesByNpiQuery, FindProviderAddressesByNpiQueryVariables>;
export const FindProvidersByFilterDocument = gql`
    query findProvidersByFilter($filterInput: ProviderFilterInput!) {
  findProvidersByFilter(filterInput: $filterInput) {
    addresses {
      addressLine1
      addressLine2
      id
      specialty
    }
    pcpDetails {
      networkDetails {
        carrierName
        name
      }
      pcpId
      id
    }
    addressesNumber
    name
    npi
  }
}
    `;

/**
 * __useFindProvidersByFilterQuery__
 *
 * To run a query within a React component, call `useFindProvidersByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProvidersByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProvidersByFilterQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useFindProvidersByFilterQuery(baseOptions: Apollo.QueryHookOptions<FindProvidersByFilterQuery, FindProvidersByFilterQueryVariables> & ({ variables: FindProvidersByFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindProvidersByFilterQuery, FindProvidersByFilterQueryVariables>(FindProvidersByFilterDocument, options);
      }
export function useFindProvidersByFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindProvidersByFilterQuery, FindProvidersByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindProvidersByFilterQuery, FindProvidersByFilterQueryVariables>(FindProvidersByFilterDocument, options);
        }
export function useFindProvidersByFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindProvidersByFilterQuery, FindProvidersByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindProvidersByFilterQuery, FindProvidersByFilterQueryVariables>(FindProvidersByFilterDocument, options);
        }
export type FindProvidersByFilterQueryHookResult = ReturnType<typeof useFindProvidersByFilterQuery>;
export type FindProvidersByFilterLazyQueryHookResult = ReturnType<typeof useFindProvidersByFilterLazyQuery>;
export type FindProvidersByFilterSuspenseQueryHookResult = ReturnType<typeof useFindProvidersByFilterSuspenseQuery>;
export type FindProvidersByFilterQueryResult = Apollo.QueryResult<FindProvidersByFilterQuery, FindProvidersByFilterQueryVariables>;
export const PackagesDocument = gql`
    query packages($rxcui: String!) {
  packages(rxcui: $rxcui) {
    name
    rxcui
  }
}
    `;

/**
 * __usePackagesQuery__
 *
 * To run a query within a React component, call `usePackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesQuery({
 *   variables: {
 *      rxcui: // value for 'rxcui'
 *   },
 * });
 */
export function usePackagesQuery(baseOptions: Apollo.QueryHookOptions<PackagesQuery, PackagesQueryVariables> & ({ variables: PackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagesQuery, PackagesQueryVariables>(PackagesDocument, options);
      }
export function usePackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagesQuery, PackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagesQuery, PackagesQueryVariables>(PackagesDocument, options);
        }
export function usePackagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PackagesQuery, PackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PackagesQuery, PackagesQueryVariables>(PackagesDocument, options);
        }
export type PackagesQueryHookResult = ReturnType<typeof usePackagesQuery>;
export type PackagesLazyQueryHookResult = ReturnType<typeof usePackagesLazyQuery>;
export type PackagesSuspenseQueryHookResult = ReturnType<typeof usePackagesSuspenseQuery>;
export type PackagesQueryResult = Apollo.QueryResult<PackagesQuery, PackagesQueryVariables>;
export const DrugPackagesInfoDocument = gql`
    query drugPackagesInfo($rxcui: String!) {
  drugPackagesInfo(rxcui: $rxcui) {
    genericName
    genericRxcui
    brandedDetails {
      name
      rxcui
    }
    hasBrandedPackages
    hasGenericPackages
    isGeneric
    name
    rxcui
  }
}
    `;

/**
 * __useDrugPackagesInfoQuery__
 *
 * To run a query within a React component, call `useDrugPackagesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrugPackagesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrugPackagesInfoQuery({
 *   variables: {
 *      rxcui: // value for 'rxcui'
 *   },
 * });
 */
export function useDrugPackagesInfoQuery(baseOptions: Apollo.QueryHookOptions<DrugPackagesInfoQuery, DrugPackagesInfoQueryVariables> & ({ variables: DrugPackagesInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrugPackagesInfoQuery, DrugPackagesInfoQueryVariables>(DrugPackagesInfoDocument, options);
      }
export function useDrugPackagesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrugPackagesInfoQuery, DrugPackagesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrugPackagesInfoQuery, DrugPackagesInfoQueryVariables>(DrugPackagesInfoDocument, options);
        }
export function useDrugPackagesInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DrugPackagesInfoQuery, DrugPackagesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DrugPackagesInfoQuery, DrugPackagesInfoQueryVariables>(DrugPackagesInfoDocument, options);
        }
export type DrugPackagesInfoQueryHookResult = ReturnType<typeof useDrugPackagesInfoQuery>;
export type DrugPackagesInfoLazyQueryHookResult = ReturnType<typeof useDrugPackagesInfoLazyQuery>;
export type DrugPackagesInfoSuspenseQueryHookResult = ReturnType<typeof useDrugPackagesInfoSuspenseQuery>;
export type DrugPackagesInfoQueryResult = Apollo.QueryResult<DrugPackagesInfoQuery, DrugPackagesInfoQueryVariables>;
export const DrugsWithPackageDocument = gql`
    query drugsWithPackage($pairs: [ProductPackagePairInput!]!) {
  drugsWithPackage(pairs: $pairs) {
    rxcui
    packRxcui
    packName
    name
    isGeneric
    genericRxcui
    genericName
    notSupported
  }
}
    `;

/**
 * __useDrugsWithPackageQuery__
 *
 * To run a query within a React component, call `useDrugsWithPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrugsWithPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrugsWithPackageQuery({
 *   variables: {
 *      pairs: // value for 'pairs'
 *   },
 * });
 */
export function useDrugsWithPackageQuery(baseOptions: Apollo.QueryHookOptions<DrugsWithPackageQuery, DrugsWithPackageQueryVariables> & ({ variables: DrugsWithPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrugsWithPackageQuery, DrugsWithPackageQueryVariables>(DrugsWithPackageDocument, options);
      }
export function useDrugsWithPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrugsWithPackageQuery, DrugsWithPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrugsWithPackageQuery, DrugsWithPackageQueryVariables>(DrugsWithPackageDocument, options);
        }
export function useDrugsWithPackageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DrugsWithPackageQuery, DrugsWithPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DrugsWithPackageQuery, DrugsWithPackageQueryVariables>(DrugsWithPackageDocument, options);
        }
export type DrugsWithPackageQueryHookResult = ReturnType<typeof useDrugsWithPackageQuery>;
export type DrugsWithPackageLazyQueryHookResult = ReturnType<typeof useDrugsWithPackageLazyQuery>;
export type DrugsWithPackageSuspenseQueryHookResult = ReturnType<typeof useDrugsWithPackageSuspenseQuery>;
export type DrugsWithPackageQueryResult = Apollo.QueryResult<DrugsWithPackageQuery, DrugsWithPackageQueryVariables>;
export const DrugsDocument = gql`
    query drugs($name: String!) {
  drugs(name: $name) {
    genericName
    genericRxcui
    isGeneric
    name
    rxcui
  }
}
    `;

/**
 * __useDrugsQuery__
 *
 * To run a query within a React component, call `useDrugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrugsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDrugsQuery(baseOptions: Apollo.QueryHookOptions<DrugsQuery, DrugsQueryVariables> & ({ variables: DrugsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrugsQuery, DrugsQueryVariables>(DrugsDocument, options);
      }
export function useDrugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrugsQuery, DrugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrugsQuery, DrugsQueryVariables>(DrugsDocument, options);
        }
export function useDrugsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DrugsQuery, DrugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DrugsQuery, DrugsQueryVariables>(DrugsDocument, options);
        }
export type DrugsQueryHookResult = ReturnType<typeof useDrugsQuery>;
export type DrugsLazyQueryHookResult = ReturnType<typeof useDrugsLazyQuery>;
export type DrugsSuspenseQueryHookResult = ReturnType<typeof useDrugsSuspenseQuery>;
export type DrugsQueryResult = Apollo.QueryResult<DrugsQuery, DrugsQueryVariables>;
export const PdpPlanDiscountsDocument = gql`
    query pdpPlanDiscounts($bidId: String!, $zip: String!, $countyName: String!, $clientId: UUID, $fullYear: Boolean, $planYear: PlanYear) {
  pdpPlanDiscounts: PdpPlan(
    bidId: $bidId
    zip: $zip
    clientId: $clientId
    countyName: $countyName
    fullYear: $fullYear
    planYear: $planYear
  ) {
    ...PdpPlanFields
    discountedDrugs {
      carrierCost
      costPlusCost
      costPlusDetails {
        brandName
        form
        quantity
        rxcui
        unitPrice
        url
      }
      discount
      discountBrand
      goodRxCost
      goodRxDetails {
        dosage
        form
        mobileUrl
        price
        quantity
        rxcui
        url
      }
      normalizedQuantity
      rxcui
    }
  }
}
    ${PdpPlanFieldsFragmentDoc}`;

/**
 * __usePdpPlanDiscountsQuery__
 *
 * To run a query within a React component, call `usePdpPlanDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpPlanDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpPlanDiscountsQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *      zip: // value for 'zip'
 *      countyName: // value for 'countyName'
 *      clientId: // value for 'clientId'
 *      fullYear: // value for 'fullYear'
 *      planYear: // value for 'planYear'
 *   },
 * });
 */
export function usePdpPlanDiscountsQuery(baseOptions: Apollo.QueryHookOptions<PdpPlanDiscountsQuery, PdpPlanDiscountsQueryVariables> & ({ variables: PdpPlanDiscountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpPlanDiscountsQuery, PdpPlanDiscountsQueryVariables>(PdpPlanDiscountsDocument, options);
      }
export function usePdpPlanDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpPlanDiscountsQuery, PdpPlanDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpPlanDiscountsQuery, PdpPlanDiscountsQueryVariables>(PdpPlanDiscountsDocument, options);
        }
export function usePdpPlanDiscountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpPlanDiscountsQuery, PdpPlanDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpPlanDiscountsQuery, PdpPlanDiscountsQueryVariables>(PdpPlanDiscountsDocument, options);
        }
export type PdpPlanDiscountsQueryHookResult = ReturnType<typeof usePdpPlanDiscountsQuery>;
export type PdpPlanDiscountsLazyQueryHookResult = ReturnType<typeof usePdpPlanDiscountsLazyQuery>;
export type PdpPlanDiscountsSuspenseQueryHookResult = ReturnType<typeof usePdpPlanDiscountsSuspenseQuery>;
export type PdpPlanDiscountsQueryResult = Apollo.QueryResult<PdpPlanDiscountsQuery, PdpPlanDiscountsQueryVariables>;
export const MaPlanDiscountsDocument = gql`
    query maPlanDiscounts($bidId: String!, $zip: String!, $countyName: String!, $quoteId: UUID, $fullYear: Boolean, $planYear: PlanYear) {
  maPlanDiscounts: plan(
    bidId: $bidId
    zip: $zip
    quoteId: $quoteId
    countyName: $countyName
    fullYear: $fullYear
    planYear: $planYear
  ) {
    ...MaPlanFields
    discountedDrugs {
      carrierCost
      costPlusCost
      costPlusDetails {
        brandName
        form
        quantity
        rxcui
        unitPrice
        url
      }
      discount
      discountBrand
      goodRxCost
      goodRxDetails {
        dosage
        form
        mobileUrl
        price
        quantity
        rxcui
        url
      }
      normalizedQuantity
      rxcui
    }
    prescriptionDrugDeductible @client
    prescriptionDrugDeductibleShort @client
  }
}
    ${MaPlanFieldsFragmentDoc}`;

/**
 * __useMaPlanDiscountsQuery__
 *
 * To run a query within a React component, call `useMaPlanDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaPlanDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaPlanDiscountsQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *      zip: // value for 'zip'
 *      countyName: // value for 'countyName'
 *      quoteId: // value for 'quoteId'
 *      fullYear: // value for 'fullYear'
 *      planYear: // value for 'planYear'
 *   },
 * });
 */
export function useMaPlanDiscountsQuery(baseOptions: Apollo.QueryHookOptions<MaPlanDiscountsQuery, MaPlanDiscountsQueryVariables> & ({ variables: MaPlanDiscountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaPlanDiscountsQuery, MaPlanDiscountsQueryVariables>(MaPlanDiscountsDocument, options);
      }
export function useMaPlanDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaPlanDiscountsQuery, MaPlanDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaPlanDiscountsQuery, MaPlanDiscountsQueryVariables>(MaPlanDiscountsDocument, options);
        }
export function useMaPlanDiscountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaPlanDiscountsQuery, MaPlanDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaPlanDiscountsQuery, MaPlanDiscountsQueryVariables>(MaPlanDiscountsDocument, options);
        }
export type MaPlanDiscountsQueryHookResult = ReturnType<typeof useMaPlanDiscountsQuery>;
export type MaPlanDiscountsLazyQueryHookResult = ReturnType<typeof useMaPlanDiscountsLazyQuery>;
export type MaPlanDiscountsSuspenseQueryHookResult = ReturnType<typeof useMaPlanDiscountsSuspenseQuery>;
export type MaPlanDiscountsQueryResult = Apollo.QueryResult<MaPlanDiscountsQuery, MaPlanDiscountsQueryVariables>;
export const RegulatoryVariableDocument = gql`
    query regulatoryVariable($year: PlanYear!) {
  regulatoryVariable(year: $year) {
    catastrophicCoinsurance
    catastrophicCoinsuranceBranded
    catastrophicCoinsuranceGeneric
    catastrophicCopayBranded
    catastrophicCopayGeneric
    catastrophicThreshold
    coverageGapCoinsurance
    coverageGapCopayBranded
    coverageGapCopayGeneric
    defaultDrugDeductible
    defaultInitialCoverageThreshold
    dsnpBrandedDrugMaxClientCopay
    dsnpGenericDrugMaxClientCopay
    initialCopayBranded
    initialCopayGeneric
    insulinPrice
    manufacturerTroop
    manufacturerInitialCoverageSharePerc
  }
}
    `;

/**
 * __useRegulatoryVariableQuery__
 *
 * To run a query within a React component, call `useRegulatoryVariableQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulatoryVariableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulatoryVariableQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useRegulatoryVariableQuery(baseOptions: Apollo.QueryHookOptions<RegulatoryVariableQuery, RegulatoryVariableQueryVariables> & ({ variables: RegulatoryVariableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulatoryVariableQuery, RegulatoryVariableQueryVariables>(RegulatoryVariableDocument, options);
      }
export function useRegulatoryVariableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulatoryVariableQuery, RegulatoryVariableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulatoryVariableQuery, RegulatoryVariableQueryVariables>(RegulatoryVariableDocument, options);
        }
export function useRegulatoryVariableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegulatoryVariableQuery, RegulatoryVariableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegulatoryVariableQuery, RegulatoryVariableQueryVariables>(RegulatoryVariableDocument, options);
        }
export type RegulatoryVariableQueryHookResult = ReturnType<typeof useRegulatoryVariableQuery>;
export type RegulatoryVariableLazyQueryHookResult = ReturnType<typeof useRegulatoryVariableLazyQuery>;
export type RegulatoryVariableSuspenseQueryHookResult = ReturnType<typeof useRegulatoryVariableSuspenseQuery>;
export type RegulatoryVariableQueryResult = Apollo.QueryResult<RegulatoryVariableQuery, RegulatoryVariableQueryVariables>;
export const PdpCompaniesDocument = gql`
    query pdpCompanies($filter: PdpPlansFilterInput!) {
  pdpCompanies(filter: $filter) {
    name
    count
    key
  }
}
    `;

/**
 * __usePdpCompaniesQuery__
 *
 * To run a query within a React component, call `usePdpCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpCompaniesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePdpCompaniesQuery(baseOptions: Apollo.QueryHookOptions<PdpCompaniesQuery, PdpCompaniesQueryVariables> & ({ variables: PdpCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdpCompaniesQuery, PdpCompaniesQueryVariables>(PdpCompaniesDocument, options);
      }
export function usePdpCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdpCompaniesQuery, PdpCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdpCompaniesQuery, PdpCompaniesQueryVariables>(PdpCompaniesDocument, options);
        }
export function usePdpCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PdpCompaniesQuery, PdpCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdpCompaniesQuery, PdpCompaniesQueryVariables>(PdpCompaniesDocument, options);
        }
export type PdpCompaniesQueryHookResult = ReturnType<typeof usePdpCompaniesQuery>;
export type PdpCompaniesLazyQueryHookResult = ReturnType<typeof usePdpCompaniesLazyQuery>;
export type PdpCompaniesSuspenseQueryHookResult = ReturnType<typeof usePdpCompaniesSuspenseQuery>;
export type PdpCompaniesQueryResult = Apollo.QueryResult<PdpCompaniesQuery, PdpCompaniesQueryVariables>;